import { jsxs as n, jsx as l } from "react/jsx-runtime";
import { forwardRef as o } from "react";
const i = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.03 9.257a1 1 0 0 1 1.213-.727l3.272.818a2 2 0 0 0 .97 0l3.273-.818a1 1 0 1 1 .485 1.94L13 11.28v1.9l2.314 3.239a1 1 0 1 1-1.628 1.162L12 15.221l-1.686 2.36a1 1 0 0 1-1.628-1.162L11 13.179v-1.898l-3.243-.81a1 1 0 0 1-.727-1.214",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
    ]
  }
), f4 = o(i), r = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a1 1 0 0 1 .912.589L15.804 8H22a1 1 0 0 1 .673 1.74l-5.018 4.562 1.794 5.382a1 1 0 0 1-1.368 1.224L15 19.486V22a1 1 0 1 1-2 0v-3.437l-1-.462-1 .462V22a1 1 0 1 1-2 0v-2.514l-3.08 1.422a1 1 0 0 1-1.369-1.224l1.794-5.382L1.327 9.74A1 1 0 0 1 2 8h6.196l2.893-6.411A1 1 0 0 1 12 1m0 3.432-2.246 4.98a1 1 0 0 1-.912.588H4.587l3.586 3.26a1 1 0 0 1 .276 1.056l-1.27 3.807 4.402-2.031a1 1 0 0 1 .838 0l4.401 2.031-1.269-3.807a1 1 0 0 1 .276-1.056L19.413 10h-4.255a1 1 0 0 1-.912-.589z",
        clipRule: "evenodd"
      }
    )
  }
), u4 = o(r), t = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M22 8a1 1 0 0 1-1 1h-8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10 6a1 1 0 0 0-2 0v1H3a1 1 0 0 0 0 2h5v1a1 1 0 1 0 2 0zM16 14a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-1h5a1 1 0 1 0 0-2h-5z"
        }
      )
    ]
  }
), p4 = o(t), h = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v4a1 1 0 1 1-2 0V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4.5a1 1 0 1 1 0 2H6a4 4 0 0 1-4-4z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 8a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19.631 13a3.33 3.33 0 0 0-2.131.77 3.34 3.34 0 0 0-2.131-.77c-.9 0-1.759.365-2.389 1.007a3.44 3.44 0 0 0-.98 2.407c0 .9.35 1.766.98 2.407l3.628 3.697c.49.5 1.294.5 1.784 0l3.628-3.697c.312-.317.558-.694.726-1.106a3.45 3.45 0 0 0-.726-3.708 3.4 3.4 0 0 0-1.093-.744A3.3 3.3 0 0 0 19.63 13m-.517 2.105a1.33 1.33 0 0 1 1.478.303c.128.13.231.286.301.459a1.45 1.45 0 0 1-.3 1.554L17.5 20.572l-3.092-3.151A1.44 1.44 0 0 1 14 16.414c0-.38.149-.743.408-1.006.258-.263.604-.408.96-.408.357 0 .704.145.962.408L17.5 16.6l1.17-1.193c.128-.13.279-.232.444-.302",
          clipRule: "evenodd"
        }
      )
    ]
  }
), R4 = o(h), d = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M8.23 2.76a10.16 10.16 0 0 1 5.823-.568 10.1 10.1 0 0 1 5.157 2.731L21 6.648V5a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-4.5a1 1 0 1 1 0-2h2.02l-1.703-1.641-.01-.01a8.1 8.1 0 0 0-4.141-2.194 8.16 8.16 0 0 0-4.677.455 8.07 8.07 0 0 0-3.628 2.948A7.94 7.94 0 0 0 4 12c0 1.58.473 3.126 1.36 4.442a8.07 8.07 0 0 0 3.63 2.948 8.16 8.16 0 0 0 4.676.456 8.1 8.1 0 0 0 4.14-2.195 1 1 0 0 1 1.409 1.42 10.1 10.1 0 0 1-5.162 2.737c-1.955.385-3.98.188-5.823-.567a10.07 10.07 0 0 1-4.527-3.68A9.94 9.94 0 0 1 2 12a9.94 9.94 0 0 1 1.703-5.56A10.07 10.07 0 0 1 8.23 2.76"
      }
    )
  }
), M4 = o(d), v = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M15.77 2.76a10.16 10.16 0 0 0-5.823-.568A10.1 10.1 0 0 0 4.79 4.923L3 6.648V5a1 1 0 0 0-2 0v4a.997.997 0 0 0 1 1h4.5a1 1 0 0 0 0-2H4.48l1.703-1.641.01-.01a8.1 8.1 0 0 1 4.141-2.194 8.16 8.16 0 0 1 4.677.455 8.07 8.07 0 0 1 3.629 2.948A7.94 7.94 0 0 1 20 12c0 1.58-.473 3.126-1.36 4.442a8.07 8.07 0 0 1-3.63 2.948 8.16 8.16 0 0 1-4.676.456 8.1 8.1 0 0 1-4.14-2.195 1 1 0 0 0-1.409 1.42 10.1 10.1 0 0 0 5.162 2.737c1.955.385 3.98.188 5.823-.567a10.07 10.07 0 0 0 4.528-3.68A9.94 9.94 0 0 0 22 12a9.94 9.94 0 0 0-1.703-5.56 10.07 10.07 0 0 0-4.527-3.68"
      }
    )
  }
), m4 = o(v), c = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v15.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 18.586V3a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), C4 = o(c), w = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.707 4.293a1 1 0 0 0-1.414 0l-7 7a1 1 0 0 0 0 1.414l7 7a1 1 0 0 0 1.414-1.414L5.414 13H21a1 1 0 1 0 0-2H5.414l5.293-5.293a1 1 0 0 0 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), x4 = o(w), s = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.293 4.293a1 1 0 0 1 1.414 0l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-5.293-5.293a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), z4 = o(s), g = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 7.414v8.18a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1h10.5a1 1 0 1 1 0 2H7.414l12.293 12.293a1 1 0 0 1-1.414 1.414z",
        clipRule: "evenodd"
      }
    )
  }
), S4 = o(g), f = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 .707.293l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 1 1-2 0V5.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l7-7A1 1 0 0 1 12 2",
        clipRule: "evenodd"
      }
    )
  }
), H4 = o(f), u = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M5.414 20H9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-6a1 1 0 1 1 2 0v3.586l5.293-5.293a1 1 0 0 1 1.414 1.414zM15 2a1 1 0 1 0 0 2h3.586l-5.293 5.293a1 1 0 0 0 1.414 1.414L20 5.414V9a1 1 0 1 0 2 0V3a1 1 0 0 0-1-1z"
      }
    )
  }
), A4 = o(u), p = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m16.414 9 5.293-5.293a1 1 0 0 0-1.414-1.414L15 7.586V4a1 1 0 1 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2zM9 20a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1H4a1 1 0 1 0 0 2h3.586l-5.293 5.293a1 1 0 1 0 1.414 1.414L9 16.414z"
      }
    )
  }
), V4 = o(p), R = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.53 1.68a3 3 0 0 1 2.94 0l6 3.375A3 3 0 0 1 21 7.67v5.66a3 3 0 0 1-1.36 2.512l1.357 2.348a1.5 1.5 0 0 1-1.085 2.235l-1.538.222-.962 1.221a1.5 1.5 0 0 1-2.477-.177l-1.392-2.411-.072.04a3 3 0 0 1-2.942 0l-.072-.04-1.392 2.41a1.5 1.5 0 0 1-2.477.178l-.961-1.221-1.539-.222a1.5 1.5 0 0 1-1.085-2.235l1.356-2.348A3 3 0 0 1 3 13.33V7.67a3 3 0 0 1 1.53-2.615zm4.756 16.619 1.011 1.752 1-1.27 1.598-.23-.994-1.723zm-9.187-1.47 2.615 1.47-1.011 1.752-1-1.27-1.598-.23zM12.49 3.422a1 1 0 0 0-.98 0l-6 3.375A1 1 0 0 0 5 7.67v5.66a1 1 0 0 0 .51.872l6 3.375a1 1 0 0 0 .98 0l6-3.375a1 1 0 0 0 .51-.872V7.67a1 1 0 0 0-.51-.872z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.12 6.024a1.01 1.01 0 0 1 1.76 0l1.036 1.839 2.069.417a1.01 1.01 0 0 1 .543 1.674L15.1 11.507l.242 2.097a1.01 1.01 0 0 1-1.423 1.034L12 13.76l-1.919.878a1.01 1.01 0 0 1-1.423-1.034l.242-2.097-1.428-1.553a1.01 1.01 0 0 1 .543-1.674l2.069-.417zM12 8.537l-.396.703a1.01 1.01 0 0 1-.68.494l-.791.16.546.593c.198.216.293.508.26.8l-.093.801.734-.335a1.01 1.01 0 0 1 .84 0l.734.335-.093-.801a1.01 1.01 0 0 1 .26-.8l.546-.594-.79-.16a1.01 1.01 0 0 1-.68-.493z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), B4 = o(R), M = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.152 8.126a1 1 0 0 1 .389 1.36L10.7 11H13a1 1 0 0 1 .874 1.486l-1.667 3a1 1 0 1 1-1.748-.972L11.3 13H9a1 1 0 0 1-.874-1.486l1.667-3a1 1 0 0 1 1.36-.388",
          clipRule: "evenodd"
        }
      )
    ]
  }
), F4 = o(M), m = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
        clipRule: "evenodd"
      }
    )
  }
), I4 = o(m), C = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M11 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M16 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3zM4 7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1"
        }
      )
    ]
  }
), L4 = o(C), x = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M22 7a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M3 7a3 3 0 0 1 3-3h11a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1.5a1 1 0 0 1-2 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.336 11.263a3.33 3.33 0 0 1 3.684.744 3.454 3.454 0 0 1 0 4.814l-3.628 3.697c-.49.5-1.294.5-1.784 0L1.98 16.822A3.44 3.44 0 0 1 1 14.414c0-.9.35-1.765.98-2.407A3.35 3.35 0 0 1 4.369 11c.782 0 1.534.276 2.13.77.253-.208.534-.38.837-.507M8.63 13a1.33 1.33 0 0 0-.96.408L6.5 14.6l-1.17-1.192A1.35 1.35 0 0 0 4.369 13c-.357 0-.703.145-.961.408A1.44 1.44 0 0 0 3 14.414c0 .381.149.743.408 1.007L6.5 18.572l3.092-3.151a1.453 1.453 0 0 0 0-2.013A1.33 1.33 0 0 0 8.631 13",
          clipRule: "evenodd"
        }
      )
    ]
  }
), $4 = o(x), z = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), P4 = o(z), S = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M11 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1M22 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 7a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), k4 = o(S), H = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 9a7 7 0 0 1 7-7 1 1 0 1 1 0 2 5 5 0 0 0-5 5v4.048a1 1 0 0 1-.293.707l-1.363 1.362c-.22.22-.344.52-.344.83A1.053 1.053 0 0 0 6.053 17h11.894c.581 0 1.053-.471 1.053-1.052 0-.312-.124-.61-.343-.83l-1.364-1.363a1 1 0 0 1 1.414-1.414l1.365 1.364c.594.595.927 1.4.928 2.241A3.054 3.054 0 0 1 17.947 19h-2.073a4.002 4.002 0 0 1-7.748 0H6.053A3.053 3.053 0 0 1 3 15.947c0-.84.334-1.647.928-2.242L5 12.634zm5.268 10a2 2 0 0 0 3.464 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M18 2a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0V7h-2a1 1 0 1 1 0-2h2V3a1 1 0 0 1 1-1"
        }
      )
    ]
  }
), y4 = o(H), A = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a7 7 0 0 0-7 7v3.634l-1.072 1.07A3.18 3.18 0 0 0 3 15.948 3.053 3.053 0 0 0 6.053 19h2.073a4.002 4.002 0 0 0 7.748 0h2.073A3.054 3.054 0 0 0 21 15.946c0-.84-.334-1.646-.928-2.241L19 12.634V9a7 7 0 0 0-7-7m1.732 17h-3.464a2 2 0 0 0 3.464 0m-8.424-2.308A1.05 1.05 0 0 1 5 15.947c0-.31.124-.61.344-.83l1.363-1.362A1 1 0 0 0 7 13.048V9a5 5 0 0 1 10 0v4.048a1 1 0 0 0 .293.707l1.363 1.363c.22.22.344.518.344.83 0 .58-.472 1.052-1.053 1.052H6.053c-.28 0-.547-.11-.745-.308",
        clipRule: "evenodd"
      }
    )
  }
), D4 = o(A), V = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.64 1.232A1 1 0 0 0 11 2v7.865L6.64 6.232a1 1 0 0 0-1.28 1.536L10.438 12 5.36 16.232a1 1 0 1 0 1.28 1.536L11 14.135V22a1 1 0 0 0 1.64.768l4.157-3.463a3 3 0 0 0 0-4.61L13.562 12l3.235-2.695a3 3 0 0 0 0-4.61zm2.876 6.536L13 9.865v-5.73l2.516 2.097a1 1 0 0 1 0 1.536M13 19.865v-5.73l2.516 2.097a1 1 0 0 1 0 1.536z",
        clipRule: "evenodd"
      }
    )
  }
), E4 = o(V), B = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13.375 1.073a1 1 0 0 1 .617 1.051L13.132 9H20a1 1 0 0 1 .8 1.6l-9 12a1 1 0 0 1-1.792-.724l.86-6.876H4a1 1 0 0 1-.8-1.6l9-12a1 1 0 0 1 1.175-.327M6 13h6a1 1 0 0 1 .992 1.124l-.533 4.263L18 11h-6a1 1 0 0 1-.992-1.124l.533-4.264z",
        clipRule: "evenodd"
      }
    )
  }
), b4 = o(B), F = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 5a2 2 0 0 1 2-2h6a4 4 0 0 1 3 1.354A4 4 0 0 1 15 3h6a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2h-6a2 2 0 0 0-2 2 1 1 0 1 1-2 0 2 2 0 0 0-2-2H3a2 2 0 0 1-2-2zm10 13.535A4 4 0 0 0 9 18H3V5h6a2 2 0 0 1 2 2zM13 7v11.535A4 4 0 0 1 15 18h6V5h-6a2 2 0 0 0-2 2",
        clipRule: "evenodd"
      }
    )
  }
), W4 = o(F), I = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 1a3 3 0 0 0-3 3v1H3a2 2 0 0 0-2 2v1a1 1 0 0 0 2 0V7h1v11a2 2 0 0 0 2 2v2a1 1 0 1 0 2 0v-2h8v2a1 1 0 1 0 2 0v-2a2 2 0 0 0 2-2V7h1v1a1 1 0 1 0 2 0V7a2 2 0 0 0-2-2h-1V4a3 3 0 0 0-3-3zm11 4V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1zM6 7v5h12V7zm10 8a1 1 0 1 0 0 2h2v1H6v-1h2a1 1 0 1 0 0-2H6v-1h12v1z",
        clipRule: "evenodd"
      }
    )
  }
), q4 = o(I), L = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7 1a1 1 0 0 1 1 1v1h7V2a1 1 0 1 1 2 0v1h1a4 4 0 0 1 4 4v3a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2h-1v1a1 1 0 1 1-2 0V5H8v1a1 1 0 0 1-2 0V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h1V2a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 9a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2zM5 14a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 15a1 1 0 0 1 1 1v1.586l1.207 1.207a1 1 0 0 1-1.414 1.414l-1.5-1.5A1 1 0 0 1 16 18v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.003 14C14.852 13.997 13 15.848 13 18a4 4 0 1 0 4.003-4m.002-2C13.748 11.996 11 14.743 11 18a6 6 0 1 0 6.005-6m0 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), T4 = o(L), $ = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 1a1 1 0 0 1 1 1v1h7V2a1 1 0 1 1 2 0v1h1a4 4 0 0 1 4 4v5a1 1 0 1 1-2 0V7a2 2 0 0 0-2-2h-1v1a1 1 0 1 1-2 0V5H8v1a1 1 0 0 1-2 0V5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a1 1 0 1 1 0 2H5a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h1V2a1 1 0 0 1 1-1m-2 9a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m14 1a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), U4 = o($), P = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 10a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M18 16a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2zM19 10a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1M6 14a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 2a1 1 0 0 0-2 0v1H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4h-1V2a1 1 0 1 0-2 0v1H8zM6 5v1a1 1 0 0 0 2 0V5h8v1a1 1 0 1 0 2 0V5h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), j4 = o(P), k = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M21 1a1 1 0 1 0-2 0v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0V5h2a1 1 0 1 0 0-2h-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3 8a2 2 0 0 1 2-2h8a1 1 0 1 0 0-2H5a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-7a1 1 0 1 0-2 0v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.25 8.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
), N4 = o(k), y = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M16 1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 13a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-2 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M4.25 8.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 4a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4zM3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), O4 = o(y), D = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1h4V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3zm2 1h2V5H6zm12 0V5h-2v1zM4 8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm12 2.5a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 0 1 1-1m-11 3a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), X4 = o(D), E = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8.65 3.024A3 3 0 0 1 10.908 2H19a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-7.248a3 3 0 0 1 .742-1.976zM10.908 4a1 1 0 0 0-.753.341L5.204 10H20V5a1 1 0 0 0-1-1zM20 12H4v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1zm-7 3a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), G4 = o(E), b = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.946 4.967A3 3 0 0 1 8.763 3H20a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3.168a2.165 2.165 0 0 1-2.033-2.91zM7.943 19H20a1 1 0 0 0 1-1v-5H10.193zM21 11H10.193a2 2 0 0 0-1.873 1.298L5.807 19H3.168a.165.165 0 0 1-.155-.222L7.824 5.656A1 1 0 0 1 8.763 5H20a1 1 0 0 1 1 1zm-3.765-4.18-.027-.027a1 1 0 0 0-.707-.293 1 1 0 0 0-.735.32l-1.473 1.473a1 1 0 0 0 1.414 1.414l.793-.793.793.793a1 1 0 0 0 1.414-1.414zm-2.942 7.473a1 1 0 0 1 1.414 0l.793.793.793-.793a1 1 0 0 1 1.414 1.414l-1.472 1.472-.027.028a1 1 0 0 1-.707.293 1 1 0 0 1-.735-.32l-1.473-1.473a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), Q4 = o(b), W = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 5a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v5h1a3 3 0 0 1 3 3v3.5a.5.5 0 0 0 1 0V7.828a1 1 0 0 0-.293-.707l-1.414-1.414a1 1 0 0 1 1.414-1.414l1.414 1.414A3 3 0 0 1 22 7.828V16.5a2.5 2.5 0 0 1-5 0V13a1 1 0 0 0-1-1h-1v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm3.652 4.126a1 1 0 0 1 .389 1.36L8.2 11h2.3a1 1 0 0 1 .874 1.486l-1.667 3a1 1 0 1 1-1.748-.972L8.8 13H6.5a1 1 0 0 1-.874-1.486l1.667-3a1 1 0 0 1 1.36-.388",
        clipRule: "evenodd"
      }
    )
  }
), K4 = o(W), q = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm10 3a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M8 9a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1m4 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), J4 = o(q), T = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm4 0h-2v12h2zM2 8a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm4 0H4v8h2zm3 2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm4 0h-2v6h2zM1 21a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), Y4 = o(T), U = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m16.213-2.3a1 1 0 1 0-1.427-1.4L9.75 14.445l-1.434-2.024a1 1 0 1 0-1.632 1.156l2.125 3a1 1 0 0 0 1.53.123z",
        clipRule: "evenodd"
      }
    )
  }
), Z4 = o(U), j = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.2 8.287a1 1 0 0 1 .013 1.414l-6.875 7a1 1 0 0 1-1.529-.123l-2.125-3a1 1 0 1 1 1.632-1.156l1.434 2.024 6.037-6.147a1 1 0 0 1 1.414-.012",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _4 = o(j), N = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M17.2 8.287a1 1 0 0 1 .013 1.414l-6.875 7a1 1 0 0 1-1.529-.123l-2.125-3a1 1 0 1 1 1.632-1.156l1.434 2.024 6.037-6.147a1 1 0 0 1 1.414-.012",
        clipRule: "evenodd"
      }
    )
  }
), l3 = o(N), O = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M20.698 5.284a1 1 0 0 1 .018 1.414l-10.714 11a1 1 0 0 1-1.514-.094l-3.785-5a1 1 0 1 1 1.594-1.208l3.084 4.073 9.903-10.167a1 1 0 0 1 1.414-.018",
        clipRule: "evenodd"
      }
    )
  }
), a3 = o(O), X = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 15.707a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414L12 13.586 7.707 9.293a1 1 0 0 0-1.414 1.414z",
        clipRule: "evenodd"
      }
    )
  }
), e3 = o(X), G = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.707 6.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 0 0 0 1.414l5 5a1 1 0 0 0 1.414-1.414L10.414 12l4.293-4.293a1 1 0 0 0 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), o3 = o(G), Q = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L13.586 12 9.293 7.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), n3 = o(Q), K = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 8.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L12 10.414l-4.293 4.293a1 1 0 0 1-1.414-1.414z",
        clipRule: "evenodd"
      }
    )
  }
), i3 = o(K), J = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 22a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.347 4a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zm-2.17.928A3 3 0 0 1 13.347 4V2a5 5 0 0 0-3.615 1.546zM16.347 7a3 3 0 0 1-2.989 3l.008 2a5 5 0 0 0 4.98-5z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m5.977 16.82.962-.27-.001-.005zm4.82-11.97-.924.384v.001zm3.98 9.54-.923.385.005.012zm.92.62-.025 1h.022zm4.313.01-.002 1h.002zM8.857 18a2.01 2.01 0 0 1-1.918-1.45l-1.925.54A4.01 4.01 0 0 0 8.857 20zm-1.919-1.455-2.86-10-1.923.55 2.86 10zm-2.86-10a1.99 1.99 0 0 1 .329-1.755l-1.6-1.2a3.99 3.99 0 0 0-.652 3.505zm.329-1.755c.376-.502.957-.79 1.6-.79V2a3.97 3.97 0 0 0-3.2 1.59zm1.6-.79h2.02V2h-2.02zm7.852 10.787a2.03 2.03 0 0 0 1.813 1.223l.05-2a.03.03 0 0 1-.028-.017zm1.835 1.223 4.314.01.004-2-4.313-.01zm4.316.01c.538 0 .99.452.99.99h2a3 3 0 0 0-2.99-2.99zm.99.99c0 .548-.442.99-.99.99v2A2.99 2.99 0 0 0 23 17.01zm-.99.99H8.857v2H20.01zM8.027 4c.658 0 1.248.31 1.616.821l1.623-1.17A3.98 3.98 0 0 0 8.026 2zm1.616.821q.136.188.23.413l1.847-.768a4 4 0 0 0-.454-.814zm.23.414 3.98 9.54 1.847-.77-3.98-9.54z"
        }
      )
    ]
  }
), r3 = o(J), Y = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 12a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1M12 14a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1M16 10a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t3 = o(Y), Z = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.707 11.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 1 1 1.414-1.414L11 14.586l3.293-3.293a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), h3 = o(Z), _ = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 1a2 2 0 0 0-2 2H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2zm6 4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2H6a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-6-2h4v2h-4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 18a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1M10 10a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M9 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 14a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
        }
      )
    ]
  }
), d3 = o(_), l1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6a1 1 0 0 1 1 1v4.382l3.447 1.724a1 1 0 1 1-.894 1.788l-4-2A1 1 0 0 1 11 12V7a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.947 2.192a10.16 10.16 0 0 1 5.823.567 10.07 10.07 0 0 1 4.528 3.68A9.94 9.94 0 0 1 22 12a9.94 9.94 0 0 1-1.703 5.56 10.07 10.07 0 0 1-4.527 3.68 10.16 10.16 0 0 1-5.823.568 10.1 10.1 0 0 1-5.162-2.736 1 1 0 0 1 1.408-1.42 8.1 8.1 0 0 0 4.141 2.194c1.57.31 3.198.15 4.677-.456a8.07 8.07 0 0 0 3.629-2.948A7.94 7.94 0 0 0 20 12a7.94 7.94 0 0 0-1.36-4.442 8.07 8.07 0 0 0-3.63-2.948 8.16 8.16 0 0 0-4.676-.455 8.1 8.1 0 0 0-4.14 2.194l-.011.01L4.479 8H7a1 1 0 0 1 0 2H2a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v2.648l1.79-1.725a10.1 10.1 0 0 1 5.157-2.73",
          clipRule: "evenodd"
        }
      )
    ]
  }
), v3 = o(l1), a1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 6a1 1 0 1 0-2 0v5.977a1 1 0 0 0 .65.96l4.979 1.992a1 1 0 0 0 .742-1.857L13 11.323z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 1c6.076 0 11 4.924 11 11s-4.924 11-11 11q-1.1-.002-2.146-.21a1 1 0 1 1 .388-1.961A9 9 0 0 0 21 12a9 9 0 0 0-10.758-8.829 1 1 0 0 1-.388-1.962A11 11 0 0 1 12 1M5.887 2.853A1 1 0 1 1 7 4.515 9.1 9.1 0 0 0 4.515 7a1 1 0 0 1-1.662-1.113 11.1 11.1 0 0 1 3.034-3.034M1.21 9.854a1 1 0 1 1 1.961.388 9 9 0 0 0 0 3.516 1 1 0 1 1-1.962.388 11 11 0 0 1 0-4.292M2.853 18.113A1 1 0 0 1 4.515 17 9.1 9.1 0 0 0 7 19.485a1 1 0 0 1-1.113 1.662 11.1 11.1 0 0 1-3.034-3.034"
        }
      )
    ]
  }
), c3 = o(a1), e1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 5a1 1 0 0 1 1 1v5.323l4.371 1.749a1 1 0 0 1-.742 1.857l-5-2A1 1 0 0 1 11 12V6a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), w3 = o(e1), o1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.947 1.106a1 1 0 0 1 .447 1.341L5.618 4l.776 1.553a1 1 0 0 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447M10.947 1.106a1 1 0 0 1 .447 1.341L10.618 4l.776 1.553a1 1 0 1 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447M15.947 1.106a1 1 0 0 1 .447 1.341L15.618 4l.776 1.553a1 1 0 1 1-1.788.894l-1-2a1 1 0 0 1 0-.894l1-2a1 1 0 0 1 1.341-.447"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 10a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1h1a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-1a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm16 9v-9H3v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2m2-2h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), s3 = o(o1), n1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h9A2.5 2.5 0 0 1 16 4.5v1a1 1 0 1 1-2 0v-1a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h1a1 1 0 1 1 0 2h-1A2.5 2.5 0 0 1 2 13.5zm6 6A2.5 2.5 0 0 1 10.5 8h9a2.5 2.5 0 0 1 2.5 2.5v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 8 19.5zm2.5-.5a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z",
        clipRule: "evenodd"
      }
    )
  }
), g3 = o(n1), i1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 4a1 1 0 0 1 1-1h20a1 1 0 1 1 0 2h-2v3a3 3 0 0 1-3 3h-1a3 3 0 0 1-3-3V5H2a1 1 0 0 1-1-1m14 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5zM4 10a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1zm7 5a1 1 0 0 1 1-1h2a2 2 0 0 1 2 2v4h3a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h15v-4h-2a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), f3 = o(i1), r1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v3.464c0 .88-.564 1.517-1.088 1.857A2 2 0 0 0 21 12c0 .702.361 1.32.912 1.679.524.34 1.088.977 1.088 1.858V19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3.463c0-.881.565-1.518 1.088-1.858C2.639 13.32 3 12.702 3 12s-.361-1.32-.912-1.679C1.565 9.981 1 9.344 1 8.464zm20 0H3v3.46a.2.2 0 0 0 .019.036c.026.04.079.096.159.148A4 4 0 0 1 5 12a4 4 0 0 1-1.822 3.356.6.6 0 0 0-.16.148.2.2 0 0 0-.018.036V19h18v-3.46a.1.1 0 0 0-.019-.036.6.6 0 0 0-.159-.148A4 4 0 0 1 19 12c0-1.407.727-2.644 1.822-3.356a.6.6 0 0 0 .16-.148A.1.1 0 0 0 21 8.46zm0 3.458v.002zm0 7.084v-.002zm-18 0v-.002zm0-7.084v.002z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.707 8.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0M13.75 14.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M7.75 9.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
), u3 = o(r1), t1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11.78-3.923A4 4 0 0 0 8.127 11H12a1 1 0 1 1 0 2H8.127a4 4 0 0 0 6.701 1.828 1 1 0 0 1 1.415 1.415A6 6 0 0 1 6.083 13H6a1 1 0 1 1 0-2h.084a6 6 0 0 1 10.159-3.243 1 1 0 1 1-1.415 1.415 4 4 0 0 0-2.048-1.095",
        clipRule: "evenodd"
      }
    )
  }
), p3 = o(t1), h1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-7v1h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-1H4a3 3 0 0 1-3-3zm11 11h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1z",
        clipRule: "evenodd"
      }
    )
  }
), R3 = o(h1), d1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 4a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm10-1h-4v1h4zM8 3v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V3h1a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7 19a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), M3 = o(d1), v1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.5 19a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1M9.5 7a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18 12.414V20a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V6a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v3.586l3.707 3.707a1 1 0 0 1-1.414 1.414zM7 6a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v14a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m3 = o(v1), c1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 14a1 1 0 0 1 1 1v3.92A3.08 3.08 0 0 1 17.92 22H6a3 3 0 0 1-3-3v-4a1 1 0 1 1 2 0v4a1 1 0 0 0 1 1h11.92A1.08 1.08 0 0 0 19 18.92V15a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M16.707 8.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414L11 10.586V3a1 1 0 1 1 2 0v7.586l2.293-2.293a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), C3 = o(c1), w1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.293 14.293a1 1 0 0 1 1.262-.125l.945.63.945-.63a1 1 0 0 1 1.11 0l.945.63.945-.63a1 1 0 0 1 1.262.125l1 1a1 1 0 0 1-1.414 1.414l-.42-.42-.818.545a1 1 0 0 1-1.11 0l-.945-.63-.945.63a1 1 0 0 1-1.11 0l-.818-.545-.42.42a1 1 0 0 1-1.414-1.414zM7.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1 0 1.414l-1.5 1.5a1 1 0 0 1-1.414-1.414L8.586 10l-.793-.793a1 1 0 0 1 0-1.414M16.207 7.793a1 1 0 0 1 0 1.414l-.793.793.793.793a1 1 0 0 1-1.414 1.414l-1.5-1.5a1 1 0 0 1 0-1.414l1.5-1.5a1 1 0 0 1 1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), x3 = o(w1), s1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414L8.5 9.914l-.793.793a1 1 0 0 1-1.414-1.414zM14.793 7.793a1 1 0 0 1 1.414 0l1.5 1.5a1 1 0 0 1-1.414 1.414l-.793-.793-.793.793a1 1 0 0 1-1.414-1.414zM6.224 13.369A1 1 0 0 1 7 13h10a1 1 0 0 1 .98 1.203C17.41 16.953 14.937 19 12 19s-5.41-2.047-5.98-4.797a1 1 0 0 1 .204-.834M8.447 15c.706 1.19 2.027 2 3.553 2s2.847-.81 3.553-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), z3 = o(s1), g1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 15a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), S3 = o(g1), f1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 15a4 4 0 0 0-2.829 1.172 1 1 0 0 1-1.414-1.415 6 6 0 0 1 8.486 0 1 1 0 1 1-1.415 1.415A4 4 0 0 0 12 15",
          clipRule: "evenodd"
        }
      )
    ]
  }
), H3 = o(f1), u1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.79 1.837a11 11 0 1 1 8.42 20.326A11 11 0 0 1 7.79 1.837M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M16.75 9.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.757 13.828a1 1 0 0 1 1.414 0 4 4 0 0 0 5.657 0 1 1 0 0 1 1.415 1.415 6 6 0 0 1-8.486 0 1 1 0 0 1 0-1.415",
          clipRule: "evenodd"
        }
      )
    ]
  }
), A3 = o(u1), p1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m12-.5a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm-1.001 5.25a1.25 1.25 0 1 1 .002-2.5 1.25 1.25 0 0 1-.002 2.5",
        clipRule: "evenodd"
      }
    )
  }
), V3 = o(p1), R1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 12.5a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1M10.75 15.496a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
), B3 = o(R1), M1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M6.707 1.879A3 3 0 0 1 8.828 1h6.344a3 3 0 0 1 2.12.879l4.83 4.828A3 3 0 0 1 23 8.828v6.344a3 3 0 0 1-.879 2.12l-4.828 4.83a3 3 0 0 1-2.121.878H8.828a3 3 0 0 1-2.12-.879l-4.83-4.828A3 3 0 0 1 1 15.172V8.828a3 3 0 0 1 .879-2.12zM8.828 3a1 1 0 0 0-.707.293L3.293 8.12A1 1 0 0 0 3 8.828v6.344a1 1 0 0 0 .293.707l4.828 4.828a1 1 0 0 0 .707.293h6.344a1 1 0 0 0 .707-.293l4.828-4.828a1 1 0 0 0 .293-.707V8.828a1 1 0 0 0-.293-.707L15.88 3.293A1 1 0 0 0 15.172 3z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 13a1 1 0 0 0 1-1V8a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1M10.75 15.996a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
), F3 = o(M1), m1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M21.924 2.617a1 1 0 0 0-.215-.322l-.004-.004A1 1 0 0 0 21 2h-6a1 1 0 1 0 0 2h3.586l-6.293 6.293a1 1 0 0 0 1.414 1.414L20 5.414V9a1 1 0 1 0 2 0V2.997a1 1 0 0 0-.076-.38"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13 5a1 1 0 0 0-1-1H6a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-5a1 1 0 1 0-2 0v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6a1 1 0 0 0 1-1"
        }
      )
    ]
  }
), I3 = o(m1), C1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2.707 7.293a1 1 0 0 0-1.414 1.414L2 8l-.707.707.001.001.002.002.004.004.013.013a5 5 0 0 0 .2.187c.135.122.33.29.581.492.337.27.777.598 1.311.945L1.628 13.51a1 1 0 0 0 1.744.98l1.77-3.148c.911.452 1.969.876 3.152 1.182l-.767 3.246a1 1 0 0 0 1.946.46l.788-3.334q.84.102 1.739.104c.71 0 1.206-.01 1.745-.08l.782 3.31a1 1 0 0 0 1.946-.46l-.774-3.276a22 22 0 0 0 3.15-1.166l1.78 3.162a1 1 0 0 0 1.743-.98l-1.777-3.16c.534-.346.974-.674 1.31-.944a13 13 0 0 0 .782-.679l.013-.013.004-.004.002-.002L22 8l.707.707a1 1 0 0 0-1.414-1.414m0 0-.003.003-.026.025-.118.109c-.107.097-.272.24-.49.414-.435.349-1.08.818-1.902 1.288-1.03.588-2.873 1.302-4.472 1.66-.829.186-1.251.208-2.282.208-.813 0-1.587-.08-2.317-.215-1.765-.329-3.272-.988-4.437-1.653a15 15 0 0 1-1.903-1.288 11 11 0 0 1-.607-.523l-.026-.025-.004-.004m0 0",
        clipRule: "evenodd"
      }
    )
  }
), L3 = o(C1), x1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-2.087-2.087A10.3 10.3 0 0 1 12 20c-4.148 0-7.564-2.273-10.252-6.483a2.82 2.82 0 0 1 0-3.034C2.767 8.888 3.89 7.567 5.127 6.541L3.293 4.707a1 1 0 0 1 0-1.414m3.256 4.67c-1.1.88-2.14 2.07-3.115 3.597a.82.82 0 0 0 0 .881C5.872 16.26 8.729 18 12 18a8.3 8.3 0 0 0 3.728-.857l-1.696-1.697a4.001 4.001 0 0 1-5.478-5.478zm3.519 3.52a1.999 1.999 0 0 0 2.45 2.45zM12 6q-.929 0-1.792.184a1 1 0 0 1-.416-1.956A10.6 10.6 0 0 1 12 4c4.148 0 7.564 2.273 10.252 6.483.59.924.591 2.108 0 3.034a19.6 19.6 0 0 1-1.561 2.13 1 1 0 1 1-1.525-1.294q.721-.85 1.4-1.913a.82.82 0 0 0 0-.881C18.128 7.74 15.272 6 12 6",
        clipRule: "evenodd"
      }
    )
  }
), $3 = o(x1), z1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 6c-3.271 0-6.128 1.74-8.566 5.559a.82.82 0 0 0 0 .882C5.872 16.26 8.728 18 12 18c3.271 0 6.128-1.74 8.566-5.559a.82.82 0 0 0 0-.882C18.128 7.74 15.272 6 12 6M1.748 10.483C4.436 6.273 7.852 4 12 4s7.564 2.273 10.252 6.483c.59.925.59 2.11 0 3.034C19.564 17.727 16.148 20 12 20s-7.564-2.273-10.252-6.483a2.82 2.82 0 0 1 0-3.034M12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
        clipRule: "evenodd"
      }
    )
  }
), P3 = o(z1), S1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-1.5a1 1 0 1 1 0-2H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-6v2h.5a1 1 0 1 1 0 2H13v1h.5a1 1 0 1 1 0 2H13v1h.5a1 1 0 1 1 0 2H13a1 1 0 1 1-2 0v-1h-.5a1 1 0 0 1 0-2h.5v-1h-.5a1 1 0 1 1 0-2h.5V7h-.5a1 1 0 0 1 0-2h.5V4zm7 14a1 1 0 0 0-1 1v2h2v-2a1 1 0 0 0-1-1m-2.121-1.121A3 3 0 0 1 15 19v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a3 3 0 0 1 .879-2.121",
        clipRule: "evenodd"
      }
    )
  }
), k3 = o(S1), H1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 3.75A2.75 2.75 0 0 1 5.75 1h1.42a1 1 0 1 1 0 2H5.75a.75.75 0 0 0-.75.75V5a1 1 0 1 1-2 0zM9.58 2a1 1 0 0 1 1-1H12v2h-1.42a1 1 0 0 1-1-1M4 7a1 1 0 0 1 1 1v2.5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1m17 3v.722a1 1 0 1 1-2 0V10zM4 12.5a1 1 0 0 1 1 1V16a1 1 0 1 1-2 0v-2.5a1 1 0 0 1 1-1m16 .153a1 1 0 0 1 1 1v2.444a1 1 0 1 1-2 0v-2.444a1 1 0 0 1 1-1M4 18a1 1 0 0 1 1 1v1.25c0 .414.336.75.75.75h1.42a1 1 0 1 1 0 2H5.75A2.75 2.75 0 0 1 3 20.25V19a1 1 0 0 1 1-1m16 .028a1 1 0 0 1 1 1v1.222A2.75 2.75 0 0 1 18.25 23h-1.42a1 1 0 0 1 0-2h1.42a.75.75 0 0 0 .75-.75v-1.222a1 1 0 0 1 1-1M9.58 22a1 1 0 0 1 1-1h2.84a1 1 0 1 1 0 2h-2.84a1 1 0 0 1-1-1M12 3V1h2.172a3 3 0 0 1 2.12.879l3.83 3.828A3 3 0 0 1 21 7.828V10h-6a3 3 0 0 1-3-3zm2 0v4a1 1 0 0 0 1 1h4v-.172a1 1 0 0 0-.293-.707L14.88 3.293A1 1 0 0 0 14.172 3z",
        clipRule: "evenodd"
      }
    )
  }
), y3 = o(H1), A1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9h-4a2 2 0 0 1-2-2V3zm9 .414V7h3.586zM21 7a1 1 0 0 0-.293-.707l-5-5A1 1 0 0 0 15 1H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7M7 9a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), D3 = o(A1), V1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10h-4a3 3 0 0 1-3-3V3zm8 0v4a1 1 0 0 0 1 1h4v-.172a1 1 0 0 0-.293-.707L14.88 3.293A1 1 0 0 0 14.172 3zm7 4.828a3 3 0 0 0-.879-2.12l-3.828-3.83A3 3 0 0 0 14.172 1H6a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3z",
        clipRule: "evenodd"
      }
    )
  }
), E3 = o(V1), B1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8.995h-3.5a2.5 2.5 0 0 1-2.5-2.5V3zm5 0v3.495a.5.5 0 0 0 .5.5H19v-.13a1 1 0 0 0-.282-.697L17.29 4.695l-1.38-1.398A1 1 0 0 0 15.2 3zM7 4a3 3 0 0 1 3-3h5.199a3 3 0 0 1 2.135.892L18.722 3.3l1.432 1.477A3 3 0 0 1 21 6.864V17a3 3 0 0 1-3 3h-1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm0 2H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1h-5a3 3 0 0 1-3-3z",
        clipRule: "evenodd"
      }
    )
  }
), b3 = o(B1), F1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 8a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m3 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1m3 4a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), W3 = o(F1), I1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6.693 3.355a2 2 0 0 1 2.45-1.415l9.659 2.589a3 3 0 0 1 2.12 3.674l-1.552 5.795a3 3 0 0 1-3.674 2.122l-9.66-2.589-2.07 7.728a1 1 0 0 1-1.932-.518zM6.554 11.6l9.66 2.588a1 1 0 0 0 1.224-.707l1.553-5.796a1 1 0 0 0-.707-1.225l-9.66-2.588zm2.519-5.537a1 1 0 0 1 1.225-.707l.966.259a1 1 0 1 1-.518 1.931l-.966-.258a1 1 0 0 1-.707-1.225m5.795 1.553a1 1 0 0 1 1.225-.707l.966.259a1 1 0 1 1-.518 1.931l-.965-.258a1 1 0 0 1-.708-1.225M11.453 8.77a1 1 0 0 1 1.225-.707l.966.259a1 1 0 0 1-.518 1.932l-.966-.26a1 1 0 0 1-.707-1.224M8.038 9.927a1 1 0 0 1 1.224-.708l.966.26a1 1 0 0 1-.517 1.931l-.966-.259a1 1 0 0 1-.707-1.224m5.795 1.553a1 1 0 0 1 1.225-.708l.966.26a1 1 0 1 1-.518 1.931l-.966-.259a1 1 0 0 1-.707-1.225",
        clipRule: "evenodd"
      }
    )
  }
), q3 = o(I1), L1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4.222 4.222a1 1 0 0 1 1.414 0L12 10.586l6.364-6.364a1 1 0 1 1 1.414 1.414L13.414 12l6.364 6.364a1 1 0 0 1-1.414 1.414L12 13.414l-6.364 6.364a1 1 0 1 1-1.414-1.414L10.586 12 4.222 5.636a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
), T3 = o(L1), $1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.968 6.382A8.96 8.96 0 0 0 3 12a9 9 0 0 0 9 9 8.96 8.96 0 0 0 5.618-1.968zm-.746-2.16A10.97 10.97 0 0 0 1 12c0 6.076 4.924 11 11 11 3.037 0 5.786-1.23 7.776-3.22l.002-.002.002-.001C21.77 17.787 23 15.037 23 12c0-6.076-4.924-11-11-11a10.97 10.97 0 0 0-7.778 3.222m2.16.746 12.65 12.65A8.96 8.96 0 0 0 21 12a9 9 0 0 0-9-9 8.96 8.96 0 0 0-5.618 1.968",
        clipRule: "evenodd"
      }
    )
  }
), U3 = o($1), P1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.459 4.313a.98.98 0 0 0-1.434 0 1.177 1.177 0 0 0 0 1.606c.528.55 1.3.844 1.97.981a9 9 0 0 0 .002-.586 5.5 5.5 0 0 0-.158-1.22c-.1-.38-.237-.633-.38-.782M12 3.035l-.099-.108a2.98 2.98 0 0 0-4.318 0A3.18 3.18 0 0 0 7.325 7H4a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2v7a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.325a3.18 3.18 0 0 0-.258-4.073A2.98 2.98 0 0 0 12 3.035m1 3.616v-.167l.003-.17c.013-.423.06-.85.158-1.22.1-.38.237-.633.38-.781a.98.98 0 0 1 1.434 0 1.177 1.177 0 0 1 0 1.606c-.528.55-1.3.844-1.97.981zM11 9H4v2h7zm0 4H6v7h5zm2 7v-7h5v7zm5.995-9H13V9h7v2h-1.005",
        clipRule: "evenodd"
      }
    )
  }
), j3 = o(P1), k1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.918 1.003Q10.958 1 11 1h4.3c1.152 0 2.204.658 2.701 1.697l.001.002L18.63 4H22a1 1 0 0 1 1 1v1.76a3 3 0 0 1-1.662 2.684L19 10.617V11h1a1 1 0 1 1 0 2h-.674l1.458 5.104A3.01 3.01 0 0 1 23 21v1a1 1 0 0 1-1 1h-5a1 1 0 0 1-.962-.726L14.535 17h-1.12l-1.24 1.24A3.01 3.01 0 0 1 14 21v1a1 1 0 0 1-1 1H5c-1.652 0-3-1.348-3-3v-8.586l-.707-.707a1 1 0 0 1 1.414-1.414l1 1A1 1 0 0 1 4 11v2.706l2.275-2.395a1 1 0 0 1 1.45 1.378l-3.41 3.59-.027.027A.97.97 0 0 0 4 17v3c0 .548.452 1 1 1h7c0-.548-.452-1-1-1h-1a1 1 0 0 1-.707-1.707l3-3A1 1 0 0 1 13 15h2.29a1 1 0 0 1 .962.726L17.755 21H21c0-.548-.452-1-1-1a1 1 0 0 1-.962-.725L17.246 13H10a1 1 0 1 1 0-2h7v-1a1 1 0 0 1 .552-.894l2.89-1.45A1 1 0 0 0 21 6.76V6h-3a1 1 0 0 1-.901-.566l-.9-1.87-.001-.003A.99.99 0 0 0 15.3 3h-2.24v6a1 1 0 0 1-1 1h-1c-1.652 0-3-1.348-3-3V4a3.006 3.006 0 0 1 2.858-2.997M10.06 4c0-.548.452-1 1-1v5c-.548 0-1-.452-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1.293 4.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414l-4-4a1 1 0 0 1 0-1.414"
        }
      )
    ]
  }
), N3 = o(k1), y1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.293 2.293A1 1 0 0 1 5 2h7a1 1 0 0 1 1 1v3.007l6.007.043a1 1 0 0 1 .694.287l3 2.95a1 1 0 0 1 .007 1.419l-3 3.01a1 1 0 0 1-.708.294h-6V22a1 1 0 1 1-2 0V10H5a1 1 0 0 1-.707-.293l-3-3a1 1 0 0 1 0-1.414zM11 7V8H5.414l-2-2 2-2H11v3m2 5.009h5.585l1.996-2.003-1.993-1.96L13 8.007z",
        clipRule: "evenodd"
      }
    )
  }
), O3 = o(y1), D1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1v2a3 3 0 0 1-3 3h-1.17A3 3 0 0 1 13 23h-2a3 3 0 1 1 0-6h2c1.306 0 2.418.835 2.83 2H17a1 1 0 0 0 1-1V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1zm10 14a1 1 0 0 0-1-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 1-1M4 10H3v4h1zm16 0v4h1v-4z",
        clipRule: "evenodd"
      }
    )
  }
), X3 = o(D1), E1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M11.36 4.335a1 1 0 0 1 1.28 0l7 5.834a1 1 0 0 1 .36.768V19a1 1 0 0 1-1 1h-3a1 1 0 1 0 0 2h3a3 3 0 0 0 3-3v-8.063a3 3 0 0 0-1.08-2.305l-7-5.833a3 3 0 0 0-3.84 0l-7 5.833A3 3 0 0 0 2 10.937V19a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3v-4.585l1.293 1.292a1 1 0 1 0 1.414-1.414l-2.973-2.972a1 1 0 0 0-1.469 0l-2.972 2.972a1 1 0 1 0 1.414 1.414L11 14.414V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8.063a1 1 0 0 1 .36-.768z"
      }
    )
  }
), G3 = o(E1), b1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l3.044 3.044-2.258 1.881A3 3 0 0 0 2 10.937V19a3 3 0 0 0 3 3h15.586l.707.707a1 1 0 0 0 1.414-1.414zM18.586 20 6.756 8.171 4.36 10.169a1 1 0 0 0-.36.768V19a1 1 0 0 0 1 1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.92 2.799a3 3 0 0 0-3.84 0L8.767 3.892a1 1 0 1 0 1.28 1.536l1.312-1.093a1 1 0 0 1 1.28 0l7 5.834a1 1 0 0 1 .36.768V16a1 1 0 1 0 2 0v-5.063a3 3 0 0 0-1.08-2.305z"
        }
      )
    ]
  }
), Q3 = o(b1), W1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.64 4.335a1 1 0 0 0-1.28 0l-7 5.834a1 1 0 0 0-.36.768V19a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-8.063a1 1 0 0 0-.36-.768zM10.08 2.8a3 3 0 0 1 3.84 0l7 5.833A3 3 0 0 1 22 10.937V19a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8.063a3 3 0 0 1 1.08-2.305z",
        clipRule: "evenodd"
      }
    )
  }
), K3 = o(W1), q1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 .65.937L8.585 14a2 2 0 0 1 2.828 0l1.086 1.086L15.586 12a2 2 0 0 1 2.828 0L21 14.586V6a1 1 0 0 0-1-1zm17 12.414-4-4-3.793 3.793a1 1 0 0 1-1.414 0L10 15.414 6.414 19H20a1 1 0 0 0 1-1zM7 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
), J3 = o(q1), T1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m10.999-5.25a1.25 1.25 0 1 0 .002 2.5A1.25 1.25 0 0 0 12 6.75M13 12a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z",
        clipRule: "evenodd"
      }
    )
  }
), Y3 = o(T1), U1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 8.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 11a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Z3 = o(U1), j1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.585 10.058A3 3 0 0 0 10.172 12H13a1 1 0 1 1 0 2h-2.828a3 3 0 0 0 3.413 1.942 3 3 0 0 0 1.536-.82 1 1 0 0 1 1.414 1.413A5 5 0 0 1 8.102 14H8a1 1 0 1 1 0-2h.101a4.999 4.999 0 0 1 8.434-2.536 1 1 0 1 1-1.414 1.415 3 3 0 0 0-1.536-.821M7 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M3 3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v18h14z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _3 = o(j1), N1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm3 11a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M7.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M11.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M15.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M19.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M19.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      )
    ]
  }
), ll = o(N1), O1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6a5 5 0 0 0-2.903 9.071c.509.364.903.973.903 1.703V17h4v-.226c0-.73.394-1.339.903-1.703A5 5 0 0 0 12 6m-7 5a7 7 0 1 1 11.066 5.699.2.2 0 0 0-.06.063l-.006.014V17a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-.224l-.006-.014a.2.2 0 0 0-.06-.063A7 7 0 0 1 5 11M9 21a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M3.84 5.134a1 1 0 0 0-1 1.732l.866.5a1 1 0 1 0 1-1.732zM2 10a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM21 10a1 1 0 1 0 0 2h1a1 1 0 1 0 0-2zM18.928 15a1 1 0 0 1 1.366-.366l.866.5a1 1 0 0 1-1 1.732l-.866-.5A1 1 0 0 1 18.928 15M18.928 7a1 1 0 0 1 .366-1.366l.866-.5a1 1 0 0 1 1 1.732l-.866.5A1 1 0 0 1 18.928 7M2.84 15.134a1 1 0 1 0 1 1.732l.866-.5a1 1 0 1 0-1-1.732z"
        }
      )
    ]
  }
), al = o(O1), X1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.828 4.858a4 4 0 0 1 5.657 0L21.9 6.272a4 4 0 0 1 0 5.657l-5.657 5.657a4 4 0 0 1-5.657 0l-1.414-1.414a4 4 0 0 1 0-5.657l.707-.707a1 1 0 0 1 1.414 1.414l-.707.707a2 2 0 0 0 0 2.828L12 16.172a2 2 0 0 0 2.828 0l5.657-5.657a2 2 0 0 0 0-2.829l-1.414-1.414a2 2 0 0 0-2.828 0 1 1 0 1 1-1.415-1.414M12 7.828a2 2 0 0 0-2.828 0l-5.657 5.657a2 2 0 0 0 0 2.829l1.414 1.414a2 2 0 0 0 2.828 0 1 1 0 0 1 1.415 1.414 4 4 0 0 1-5.657 0L2.1 17.728a4 4 0 0 1 0-5.657l5.656-5.657a4 4 0 0 1 5.657 0l1.414 1.414a4 4 0 0 1 0 5.657l-.707.707a1 1 0 0 1-1.414-1.414l.707-.707a2 2 0 0 0 0-2.828z",
        clipRule: "evenodd"
      }
    )
  }
), el = o(X1), G1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 9a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2a4 4 0 0 1-4 4h-1a1 1 0 1 1 0-2h1a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2 1 1 0 1 1 0 2 4 4 0 0 1-4-4zm10 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2 1 1 0 1 1 0-2 4 4 0 0 1 4 4v2a4 4 0 0 1-4 4h-8a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4h1a1 1 0 1 1 0 2z",
        clipRule: "evenodd"
      }
    )
  }
), ol = o(G1), Q1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 18.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M8 5.5a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 12a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M6 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }
      )
    ]
  }
), nl = o(Q1), K1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 1a4 4 0 0 0-4 4 1 1 0 0 0 2 0 2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1V5a4 4 0 0 0-4-4zM6 11a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), il = o(K1), J1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11 1a4 4 0 0 0-4 4v4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1V5a4 4 0 0 0-4-4zm4 8V5a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4zm-9 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), rl = o(J1), Y1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14 3a1 1 0 0 1 1-1h4a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-4a1 1 0 1 1 0-2h4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1M9.293 6.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L12.586 13H3a1 1 0 1 1 0-2h9.586L9.293 7.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), tl = o(Y1), Z1 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h4a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h4a1 1 0 0 1 0 2zm10.293 2.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L18.586 13H9a1 1 0 1 1 0-2h9.586l-3.293-3.293a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), hl = o(Z1), _1 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15.207 9.207a1 1 0 0 0-1.414-1.414L11.5 10.086l-.793-.793a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414 0z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.176 2.618a3 3 0 0 1 3.648 0l7 5.36A3 3 0 0 1 22 10.36V19a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8.64A3 3 0 0 1 3.176 7.98zm2.432 1.588a1 1 0 0 0-1.216 0L4.788 9.263l6.61 5.283a1 1 0 0 0 1.203 0l6.603-5.289zM4 19v-7.806l6.16 4.922.015.013a3 3 0 0 0 3.65 0l.017-.014L20 11.183V19a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), dl = o(_1), l0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M19 4a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4zm2 4a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.136 8.496a1 1 0 0 1 1.368-.36L12 11.342l5.496-3.206a1 1 0 0 1 1.008 1.728l-5.496 3.206a2 2 0 0 1-2.016 0L5.496 9.864a1 1 0 0 1-.36-1.368",
          clipRule: "evenodd"
        }
      )
    ]
  }
), vl = o(l0), a0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.684 2.051a1 1 0 0 1 .632 0l5.317 1.772A2 2 0 0 1 22 5.721V10a1 1 0 1 1-2 0V5.72l-4-1.333V10a1 1 0 1 1-2 0V4.387l-4 1.334V11a1 1 0 1 1-2 0V5.72L4 4.388v13.92l3.351 1.257a1 1 0 1 1-.702 1.872L3.298 20.18A2 2 0 0 1 2 18.307V4.387A2 2 0 0 1 4.632 2.49L9 3.946zM10 15.5a2.5 2.5 0 0 1 2.5-2.5h1a2.5 2.5 0 0 1 2.5 2.5V21a1 1 0 1 1-2 0v-2h-2v2a1 1 0 1 1-2 0zm2 1.5h2v-1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm5-2.75c0-.69.56-1.25 1.25-1.25H20a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-1.75c-.69 0-1.25-.56-1.25-1.25zm2 .75v5h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z",
        clipRule: "evenodd"
      }
    )
  }
), cl = o(a0), e0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a9 9 0 0 0-6 15.709l5.142 4.856a1.25 1.25 0 0 0 1.716 0L18 16.708q.186-.167.364-.344A9 9 0 0 0 12 1m-7 9a7 7 0 1 1 11.658 5.226l-.011.01-.01.009L12 19.625l-4.637-4.38-.01-.01-.01-.01A7 7 0 0 1 5 10m8-3a1 1 0 1 0-2 0v2H9a1 1 0 0 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2z",
        clipRule: "evenodd"
      }
    )
  }
), wl = o(e0), o0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3C9.334 3 7.222 5.093 7.222 7.618c0 .832.288 1.745.787 2.689.495.937 1.167 1.846 1.86 2.652a24 24 0 0 0 2.13 2.168l.226-.205c.522-.48 1.215-1.16 1.905-1.963.693-.806 1.365-1.715 1.86-2.652.5-.944.787-1.857.787-2.69C16.777 5.094 14.665 3 12 3m0 14.22-.625.006-.002-.002-.004-.004-.016-.012-.054-.044-.196-.164a25.812 25.812 0 0 1-2.751-2.737c-.751-.875-1.524-1.91-2.112-3.022-.584-1.106-1.018-2.349-1.018-3.623C5.222 3.936 8.282 1 12 1c3.716 0 6.777 2.936 6.777 6.618 0 1.274-.434 2.517-1.018 3.623-.588 1.113-1.36 2.147-2.112 3.022a26 26 0 0 1-3.001 2.945l-.015.012-.005.004-.001.001zm0 0 .625.005a1 1 0 0 1-1.25 0z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.654 7.123a.926.926 0 1 0-1.31 1.31.926.926 0 0 0 1.31-1.31m1.413-1.415a2.926 2.926 0 1 0-4.138 4.137 2.926 2.926 0 0 0 4.139-4.136zM17.722 13.565a1 1 0 0 1 1.273-.616c1.086.378 2.044.862 2.749 1.458.701.593 1.256 1.39 1.256 2.37 0 1.386-1.079 2.403-2.269 3.074-1.248.704-2.943 1.224-4.854 1.523a1 1 0 0 1-.31-1.976c1.768-.276 3.211-.742 4.182-1.29 1.03-.58 1.251-1.08 1.251-1.33 0-.17-.092-.458-.547-.843-.452-.382-1.161-.765-2.115-1.097a1 1 0 0 1-.616-1.273M6.278 13.565a1 1 0 0 1-.616 1.273c-.954.332-1.663.715-2.115 1.097-.455.385-.547.674-.547.843 0 .162.08.426.463.777.382.352.991.715 1.828 1.04 1.122.437 2.563.771 4.2.943a1 1 0 0 1 1.55-1.245l1.666 1.666a1 1 0 0 1 0 1.415L11.04 23.04a1 1 0 1 1-1.414-1.414l.06-.06c-1.946-.172-3.71-.558-5.12-1.106-.972-.379-1.828-.854-2.457-1.432-.63-.58-1.109-1.339-1.109-2.25 0-.98.555-1.778 1.256-2.37.705-.597 1.663-1.081 2.749-1.46a1 1 0 0 1 1.273.617",
          clipRule: "evenodd"
        }
      )
    ]
  }
), sl = o(o0), n0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 10a9 9 0 1 1 15 6.709l-5.142 4.856a1.25 1.25 0 0 1-1.716 0L6 16.708A8.975 8.975 0 0 1 3 10m9-7a7 7 0 0 0-4.658 12.226l.011.01L12 19.623l4.647-4.389.01-.01q.15-.132.293-.275A7 7 0 0 0 12 3m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
        clipRule: "evenodd"
      }
    )
  }
), gl = o(n0), i0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.684 2.051a1 1 0 0 1 .632 0l5.317 1.772A2 2 0 0 1 22 5.721v13.892a2 2 0 0 1-2.633 1.897L15 20.054 9.316 21.95a1 1 0 0 1-.632 0l-5.316-1.772A2 2 0 0 1 2 18.279V4.387A2 2 0 0 1 4.632 2.49L9 3.946zM8 5.721 4 4.387V18.28l4 1.334zm2 13.892 4-1.334V4.387l-4 1.334zm6-15.226V18.28l4 1.334V5.72z",
        clipRule: "evenodd"
      }
    )
  }
), fl = o(i0), r0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 9a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1m0 6a1 1 0 0 1 1-1h13a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), ul = o(r0), t0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M6.999 9.5a1.5 1.5 0 1 0 .003 3 1.5 1.5 0 0 0-.003-3M10.5 11.004a1.5 1.5 0 1 1 3-.008 1.5 1.5 0 0 1-3 .008M16.999 9.5a1.5 1.5 0 1 0 .003 3 1.5 1.5 0 0 0-.003-3"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 3a3 3 0 0 0-3 3v14.006c0 1.692 1.97 2.62 3.273 1.542l2.81-2.32A1 1 0 0 1 7.718 19H20a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zM3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7.719a3 3 0 0 0-1.91.687L3 20.007z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), pl = o(t0), h0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 0 0-2 2 1 1 0 0 1-2 0 4 4 0 0 1 8 0v5c0 .395-.058.787-.173 1.165a1 1 0 0 1-1.914-.582A2 2 0 0 0 14 10V5a2 2 0 0 0-2-2m-8.707.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-3.606-3.606a8 8 0 0 1-2.687.838V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-3.061a8 8 0 0 1-7-7.94A1 1 0 1 1 6 10a6 6 0 0 0 8.178 5.592l-1.627-1.627A4 4 0 0 1 8 10.002v-.588L3.293 4.707a1 1 0 0 1 0-1.414M18.996 9a1 1 0 0 1 1.002.998 7.97 7.97 0 0 1-1.317 4.403 1 1 0 0 1-1.67-1.102 5.97 5.97 0 0 0 .987-3.297A1 1 0 0 1 18.996 9",
        clipRule: "evenodd"
      }
    )
  }
), Rl = o(h0), d0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a2 2 0 0 0-2 2v5a2 2 0 0 0 4 0V5a2 2 0 0 0-2-2m-2.828-.828A4 4 0 0 1 16 5v5a4 4 0 1 1-8 0V5a4 4 0 0 1 1.172-2.828",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5 9a1 1 0 0 1 1 1 6 6 0 1 0 12 0 1 1 0 1 1 2 0 8 8 0 0 1-7 7.937V21h3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2h3v-3.063A8 8 0 0 1 4 10a1 1 0 0 1 1-1"
        }
      )
    ]
  }
), Ml = o(d0), v0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m15 1a1 1 0 1 0 0-2H8a1 1 0 1 0 0 2z",
        clipRule: "evenodd"
      }
    )
  }
), ml = o(v0), c0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 12a1 1 0 0 1-1 1H8a1 1 0 1 1 0-2h8a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Cl = o(c0), w0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), xl = o(w0), s0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.731 2.39a1 1 0 0 1 .09 1.081 7 7 0 0 0 9.471 9.471 1 1 0 0 1 1.444 1.11c-1.035 4.42-5 7.71-9.736 7.71-5.523 0-10-4.476-10-10 0-4.735 3.291-8.7 7.71-9.736a1 1 0 0 1 1.021.365M8.238 4.7a8 8 0 1 0 10.825 10.825A9 9 0 0 1 8.237 4.7",
        clipRule: "evenodd"
      }
    )
  }
), zl = o(s0), g0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M6 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M22 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      }
    )
  }
), Sl = o(g0), f0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4M12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4M12 21a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      }
    )
  }
), Hl = o(f0), u0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M20.243 5.366c.377-1.005-.604-1.986-1.61-1.61L3.81 9.317c-1.103.413-1.074 1.983.044 2.356l6.355 2.119 2.119 6.355c.373 1.118 1.943 1.147 2.356.044z"
      }
    )
  }
), Al = o(u0), p0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m14.828 9.172-6.524 2.372 2.965 1.187 1.187 2.965zm1.129-2.539c.878-.319 1.729.532 1.41 1.41l-3.838 10.553c-.345.949-1.68.97-2.055.032L9.731 14.27l-4.36-1.743c-.937-.375-.916-1.71.033-2.055z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Vl = o(p0), R0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m10.608 1.577-9.031 9.03a1.97 1.97 0 0 0 0 2.786l9.03 9.03c.77.77 2.016.77 2.786 0l9.03-9.03a1.97 1.97 0 0 0 0-2.786l-9.03-9.03a1.97 1.97 0 0 0-2.786 0m3.601 5.215a1 1 0 1 0-1.414 1.414L13.59 9h-1.586a4 4 0 0 0-4 4v3a1 1 0 1 0 2 0v-3a2 2 0 0 1 2-2h1.585l-.793.793a1 1 0 0 0 1.414 1.414l2.474-2.473.027-.027a.997.997 0 0 0-.027-1.442z",
        clipRule: "evenodd"
      }
    )
  }
), Bl = o(R0), M0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6 5a3 3 0 1 1 4.974 2.26l.774 1.75Q11.873 9 12 9c.874 0 1.659.373 2.206.967l1.8-.771a3 3 0 1 1 .788 1.838l-1.8.772Q15 11.902 15 12c0 .382-.072.747-.202 1.083l2.705 2.317a3 3 0 1 1-1.302 1.518L13.496 14.6c-.44.253-.951.399-1.496.399a3 3 0 0 1-1.496-.4L7.8 16.919A3 3 0 1 1 6.497 15.4l2.705-2.317A3 3 0 0 1 9 12c0-.852.356-1.62.925-2.166l-.812-1.836L9 8a3 3 0 0 1-3-3m13 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-7 3q-.226.002-.414.09A1 1 0 1 0 12 11m-7 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m14 0a.996.996 0 0 0-1 1 1 1 0 1 0 1-1",
        clipRule: "evenodd"
      }
    )
  }
), Fl = o(M0), m0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.455 4.162a1 1 0 0 1 .951-.076L10 7.461V5a1 1 0 1 1 2 0v4a1 1 0 0 1-1.406.914L3 6.539V9a1 1 0 1 1-2 0V5a1 1 0 0 1 .455-.838M13 7c0-1.652 1.348-3 3-3h4c1.652 0 3 1.348 3 3s-1.348 3-3 3h-4c-1.652 0-3-1.348-3-3m3-1c-.548 0-1 .452-1 1s.452 1 1 1h4c.548 0 1-.452 1-1s-.452-1-1-1zM1 14c0-1.652 1.348-3 3-3h2a1 1 0 1 1 0 2H4c-.548 0-1 .452-1 1v3c0 .548.452 1 1 1h2a1 1 0 1 1 0 2H4c-1.652 0-3-1.348-3-3zm7 0c0-1.652 1.348-3 3-3h1c1.652 0 3 1.348 3 3v3c0 1.652-1.348 3-3 3h-1c-1.652 0-3-1.348-3-3zm3-1c-.548 0-1 .452-1 1v3c0 .548.452 1 1 1h1c.548 0 1-.452 1-1v-3c0-.548-.452-1-1-1zm5-1a1 1 0 0 1 1-1h3c1.652 0 3 1.348 3 3s-1.348 3-3 3h-1c-.548 0-1 .452-1 1h4a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1v-1c0-1.652 1.348-3 3-3h1c.548 0 1-.452 1-1s-.452-1-1-1h-3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), Il = o(m0), C0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4zm4-2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 6h5a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3h-4v3a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m1 2v4h4a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ll = o(C0), x0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M6 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zM16 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
      }
    )
  }
), $l = o(x0), z0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 7a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 9a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M14 15a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Pl = o(z0), S0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 8a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1M13 14a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M4 4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h13a3 3 0 0 0 3-3V9a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 1 0 0 2h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3 3 3 0 0 0-3-3zm14 3a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), kl = o(S0), H0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14.879 2.707a3 3 0 0 1 4.242 0l2.172 2.172a3 3 0 0 1 0 4.242L9 21.414A2 2 0 0 1 7.586 22H4a2 2 0 0 1-2-2v-3.586A2 2 0 0 1 2.586 15zm2.828 1.414a1 1 0 0 0-1.414 0L4 16.414V20h3.586L19.879 7.707a1 1 0 0 0 0-1.414z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M13.293 4.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
), yl = o(H0), A0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H14a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zm12.146-.525a1 1 0 0 1 0 1.414L17.414 17H22a1 1 0 1 1 0 2h-4.586l1.293 1.293a1 1 0 0 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414l3-3a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
), Dl = o(A0), V0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H14a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zM18 15a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), El = o(V0), B0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6M7 7a5 5 0 1 1 10 0A5 5 0 0 1 7 7m-.439 7.818A3 3 0 0 1 9.32 13H13a1 1 0 1 1 0 2H9.319a1 1 0 0 0-.92.606l-2.48 5.788a1 1 0 0 1-1.838-.788zm15.146.475a1 1 0 0 1 0 1.414L19.914 18.5l1.793 1.793a1 1 0 0 1-1.414 1.414L18.5 19.914l-1.793 1.793a1 1 0 1 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 1.414-1.414l1.793 1.793 1.793-1.793a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
), bl = o(B0), F0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1a5 5 0 1 0 0 10 5 5 0 0 0 0-10M9 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.342 15.553a1 1 0 0 1 .894-.553h3.528a1 1 0 0 1 .894.553l3.448 6.894a1 1 0 1 0 1.788-.894l-3.447-6.895A3 3 0 0 0 13.764 13h-3.528a3 3 0 0 0-2.683 1.658l-3.447 6.895a1 1 0 1 0 1.788.894z"
        }
      )
    ]
  }
), Wl = o(F0), I0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m6.982 2.012-.013.002A5.73 5.73 0 0 0 2 7.695 14.306 14.306 0 0 0 16.305 22a5.732 5.732 0 0 0 5.684-4.982 1.79 1.79 0 0 0-1.071-1.85l-4.598-2.06-.013-.007a1.78 1.78 0 0 0-1.694.155 1 1 0 0 0-.091.07L12.27 15.24c-1.34-.69-2.819-2.152-3.512-3.482l1.924-2.285a1.785 1.785 0 0 0 .356-.916 1.8 1.8 0 0 0-.146-.873l-2.06-4.602a1.78 1.78 0 0 0-1.85-1.07m.104 2.064 1.918 4.285-1.945 2.31a1.781 1.781 0 0 0-.36.95c-.021.307.04.614.172.89l.002.007c.935 1.914 2.732 3.687 4.647 4.61l.005.003c.279.132.587.191.895.168a1.77 1.77 0 0 0 .947-.367l2.278-1.936 4.279 1.918c-.15.829-.526 1.607-1.162 2.164a3.73 3.73 0 0 1-2.457.922A12.304 12.304 0 0 1 4 7.695c0-.904.327-1.776.922-2.457.557-.636 1.335-1.011 2.164-1.162m8.416 10.856.02.007h-.006zM15 6a1 1 0 1 0 0 2 1 1 0 0 1 1 1 1 1 0 0 0 2 0 3 3 0 0 0-3-3"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M15 2a1 1 0 1 0 0 2 5 5 0 0 1 5 5 1 1 0 0 0 2 0 7 7 0 0 0-7-7"
        }
      )
    ]
  }
), ql = o(I0), L0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 8c-2.992 0-5.868 1.232-7.995 3.437a3.62 3.62 0 0 0-.997 2.28c-.051.79.152 1.57.569 2.218l4.001-1.582.222-2.842a1.756 1.756 0 0 1 .388-.904c.19-.231.44-.41.726-.516l.006-.002c1.828-.662 4.297-.679 6.133-.024l.007.002c.285.104.535.281.727.51a1.76 1.76 0 0 1 .393.902l.24 2.872 4.003 1.584c.417-.649.62-1.428.57-2.218a3.62 3.62 0 0 0-.997-2.28C17.869 9.233 14.992 8 12 8m-9.434 2.048C5.06 7.461 8.454 6 12 6s6.938 1.46 9.434 4.048a5.62 5.62 0 0 1 1.554 3.54 5.66 5.66 0 0 1-1.082 3.719l-.01.011a1.72 1.72 0 0 1-.91.62 1.7 1.7 0 0 1-1.1-.065l-4.371-1.73-.016-.006a1.7 1.7 0 0 1-.68-.509 1.76 1.76 0 0 1-.357-.76 1 1 0 0 1-.016-.115l-.239-2.863c-1.322-.418-3.107-.408-4.432.02l-.221 2.834a1 1 0 0 1-.015.113c-.055.28-.176.544-.356.769-.181.225-.416.403-.686.515l-.015.006-4.369 1.726a1.7 1.7 0 0 1-1.098.065 1.72 1.72 0 0 1-.912-.62l-.009-.011a5.66 5.66 0 0 1-1.082-3.718 5.62 5.62 0 0 1 1.554-3.54",
        clipRule: "evenodd"
      }
    )
  }
), Tl = o(L0), $0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M19 2a1 1 0 1 0-2 0v1.631l-1.445-.963a1 1 0 0 0-1.11 1.664L16.197 5.5l-1.752 1.168a1 1 0 0 0 1.11 1.664L17 7.37V9a1 1 0 1 0 2 0V7.369l1.445.963a1 1 0 0 0 1.11-1.664L19.803 5.5l1.752-1.168a1 1 0 0 0-1.11-1.664L19 3.631z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m6.969 2.014.013-.002a1.79 1.79 0 0 1 1.85 1.07l2.06 4.602.006.015c.116.27.165.565.14.858a1.8 1.8 0 0 1-.356.916l-1.924 2.285c.693 1.33 2.172 2.793 3.512 3.482l2.252-1.914a1 1 0 0 1 .091-.07 1.783 1.783 0 0 1 1.693-.154l.014.005 4.598 2.061a1.78 1.78 0 0 1 1.07 1.85l-.002.013A5.73 5.73 0 0 1 16.305 22 14.306 14.306 0 0 1 2 7.695a5.732 5.732 0 0 1 4.969-5.682M9.004 8.36 7.086 4.076c-.829.15-1.607.526-2.164 1.162A3.73 3.73 0 0 0 4 7.695 12.304 12.304 0 0 0 16.305 20c.904 0 1.776-.327 2.457-.922.636-.557 1.011-1.335 1.162-2.164l-4.28-1.918-2.277 1.936a1.774 1.774 0 0 1-.947.367 1.8 1.8 0 0 1-.895-.168l-.005-.002c-1.915-.924-3.712-2.697-4.647-4.611l-.002-.006a1.8 1.8 0 0 1-.172-.89 1.8 1.8 0 0 1 .36-.95zm6.518 6.578-.02-.007.014.007z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ul = o($0), P0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M8 9a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2zm6 0h-4v4h4z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9 2a1 1 0 0 0-2 0v1.126C5.275 3.57 4 5.136 4 7v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H9zM8 5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), jl = o(P0), k0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M7 1a2 2 0 0 0-2 2v1c0 1.306.835 2.417 2 2.83V10a1 1 0 0 1-1 1 3 3 0 0 0-3 3v1a2 2 0 0 0 2 2h6v5a1 1 0 1 0 2 0v-5h6a2 2 0 0 0 2-2v-1a3 3 0 0 0-3-3 1 1 0 0 1-1-1V6.83A3 3 0 0 0 19 4V3a2 2 0 0 0-2-2z"
      }
    )
  }
), Nl = o(k0), y0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1a3 3 0 0 1-2 2.83V10a1 1 0 0 0 1 1 3 3 0 0 1 3 3v1a2 2 0 0 1-2 2h-6v5a1 1 0 1 1-2 0v-5H5a2 2 0 0 1-2-2v-1a3 3 0 0 1 3-3 1 1 0 0 0 1-1V6.83A3 3 0 0 1 5 4zm14 12v-1a1 1 0 0 0-1-1 3 3 0 0 1-3-3V5h1a1 1 0 0 0 1-1V3H7v1a1 1 0 0 0 1 1h1v5a3 3 0 0 1-3 3 1 1 0 0 0-1 1v1z",
        clipRule: "evenodd"
      }
    )
  }
), Ol = o(y0), D0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M5 18.895V5.105c0-2.515 2.974-3.984 5.125-2.53L20.63 9.68c1.859 1.257 1.82 3.903-.076 5.11l-10.505 6.685C7.891 22.848 5 21.371 5 18.894"
      }
    )
  }
), Xl = o(D0), E0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.293 3.293a1 1 0 0 1 1.414 0l2.68 2.679A3.98 3.98 0 0 1 10 5h6a2 2 0 0 1 2 2v1h4a1 1 0 1 1 0 2h-4v4h4a1 1 0 1 1 0 2h-4v.586l2.707 2.707a1 1 0 0 1-1.414 1.414L8 9.414V15a2 2 0 0 0 2 2h3a1 1 0 1 1 0 2h-3a4 4 0 0 1-4-4v-2H5a2 2 0 0 0-2 2v3a1 1 0 1 1-2 0v-3a4 4 0 0 1 4-4h1V9c0-.474.083-.93.234-1.352l-2.941-2.94a1 1 0 0 1 0-1.415m5.515 4.1L16 14.587V7h-6c-.447 0-.86.146-1.192.394",
        clipRule: "evenodd"
      }
    )
  }
), Gl = o(E0), b0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10 5a4 4 0 0 0-4 4v2H5a4 4 0 0 0-4 4v3a1 1 0 1 0 2 0v-3a2 2 0 0 1 2-2h1v2a4 4 0 0 0 4 4h6a2 2 0 0 0 2-2v-1h4a1 1 0 1 0 0-2h-4v-4h4a1 1 0 1 0 0-2h-4V7a2 2 0 0 0-2-2zm6 2h-6a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6z",
        clipRule: "evenodd"
      }
    )
  }
), Ql = o(b0), W0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m12-4a1 1 0 1 0-2 0v3H8a1 1 0 1 0 0 2h3v3a1 1 0 1 0 2 0v-3h3a1 1 0 1 0 0-2h-3z",
        clipRule: "evenodd"
      }
    )
  }
), Kl = o(W0), q0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 7a1 1 0 0 1 1 1v3h3a1 1 0 1 1 0 2h-3v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Jl = o(q0), T0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 6a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2h-4v4a1 1 0 1 1-2 0v-4H7a1 1 0 1 1 0-2h4V7a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), Yl = o(T0), U0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-3a3 3 0 0 0-1 5.83v8.34A3.001 3.001 0 1 0 7.83 20h8.34A3.001 3.001 0 1 0 20 16.17V7.83A3.001 3.001 0 1 0 16.17 4H7.83A3 3 0 0 0 5 2m13 14.17V7.83A3 3 0 0 1 16.17 6H7.83A3 3 0 0 1 6 7.83v8.34A3 3 0 0 1 7.83 18h8.34A3 3 0 0 1 18 16.17M4 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0M19 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), Zl = o(U0), j0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M12 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1a1 1 0 0 1 1 1v1.055A9 9 0 0 1 20.945 11H22a1 1 0 1 1 0 2h-1.055A9 9 0 0 1 13 20.945V22a1 1 0 1 1-2 0v-1.055A9 9 0 0 1 3.055 13H2a1 1 0 1 1 0-2h1.055A9 9 0 0 1 11 3.055V2a1 1 0 0 1 1-1m0 4a7 7 0 0 0-7 7 7 7 0 0 0 7 7 7 7 0 0 0 7-7 7 7 0 0 0-7-7",
          clipRule: "evenodd"
        }
      )
    ]
  }
), _l = o(j0), N0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1m4.169 1.961a1 1 0 0 1 1.386-.276 10 10 0 1 1-11.11 0 1 1 0 1 1 1.11 1.663 8 8 0 1 0 8.89 0 1 1 0 0 1-.276-1.387",
        clipRule: "evenodd"
      }
    )
  }
), la = o(N0), O0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M11.607 9.08a1 1 0 0 1 .908.063l5 3 .085.056a1 1 0 0 1-1.024 1.706l-.09-.048L12 11.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3z"
      }
    )
  }
), aa = o(O0), X0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M11.607 12.08a1 1 0 0 1 .908.063l5 3 .084.056a1 1 0 0 1-1.023 1.706l-.09-.048L12 14.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3zM11.607 6.08a1 1 0 0 1 .908.063l5 3 .084.056a1 1 0 0 1-1.023 1.706l-.09-.048L12 8.166l-4.485 2.691a1 1 0 0 1-1.03-1.714l5-3z"
      }
    )
  }
), ea = o(X0), G0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M12.393 14.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 12.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3z"
      }
    )
  }
), oa = o(G0), Q0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M12.393 11.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 9.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3zM12.393 17.92a1 1 0 0 1-.908-.063l-5-3-.085-.056a1 1 0 0 1 1.024-1.706l.09.048L12 15.834l4.485-2.691a1 1 0 0 1 1.03 1.714l-5 3z"
      }
    )
  }
), na = o(Q0), K0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m17 8 .102.005a1 1 0 0 1 0 1.99L17 10H7a1 1 0 0 1 0-2zM17 14l.102.005a1 1 0 0 1 0 1.99L17 16H7a1 1 0 1 1 0-2z"
      }
    )
  }
), ia = o(K0), J0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 7.5a2 2 0 0 0-2 2 1 1 0 1 1-2 0 4 4 0 1 1 5 3.874v.126a1 1 0 1 1-2 0V13c0-.862.681-1.419 1.333-1.527A2 2 0 0 0 12 7.5M13.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 1C5.924 1 1 5.924 1 12s4.924 11 11 11 11-4.924 11-11S18.076 1 12 1M3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ra = o(J0), Y0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M14.053 2.192a10.16 10.16 0 0 0-5.823.567 10.07 10.07 0 0 0-4.527 3.68A1 1 0 0 0 5.36 7.56a8.07 8.07 0 0 1 3.628-2.95 8.16 8.16 0 0 1 4.677-.454 8.1 8.1 0 0 1 4.14 2.194l.011.01L19.521 8H17a1 1 0 1 0 0 2h5a.997.997 0 0 0 1-1V4a1 1 0 1 0-2 0v2.648l-1.79-1.725a10.1 10.1 0 0 0-5.157-2.73M9.947 21.808c1.955.385 3.98.188 5.823-.567a10.07 10.07 0 0 0 4.528-3.68 1 1 0 0 0-1.658-1.12 8.07 8.07 0 0 1-3.63 2.95 8.16 8.16 0 0 1-4.676.455 8.1 8.1 0 0 1-4.14-2.195l-.011-.01L4.479 16H7a1 1 0 1 0 0-2H2a.996.996 0 0 0-1 1v5a1 1 0 1 0 2 0v-2.648l1.79 1.725a10.1 10.1 0 0 0 5.157 2.73"
      }
    )
  }
), ta = o(Y0), Z0 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.783 2.024a1 1 0 0 1 1.193.76l4 18a1 1 0 0 1-1.952.433l-4-18a1 1 0 0 1 .76-1.193m-9.566 0a1 1 0 0 1 .76 1.193l-4 18a1 1 0 1 1-1.953-.434l4-18a1 1 0 0 1 1.193-.76M12 4a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1m0 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1m0 6a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), ha = o(Z0), _0 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.207 8.207a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414zM14.207 7.093a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0M19.207 8.307a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 1.414 1.414z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4h2a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h2v-4H4a3 3 0 0 1-3-3zm16 13v-4H7v4zm3-6H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), da = o(_0), l2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M22 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.5 6a2.5 2.5 0 1 0 0 5h4a4.5 4.5 0 1 1 0 9H9a1 1 0 1 1 0-2h5.5a2.5 2.5 0 0 0 0-5h-4a4.5 4.5 0 1 1 0-9H13a1 1 0 1 1 0 2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M6.5 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" })
    ]
  }
), va = o(l2), a2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M20.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.5 6a2.5 2.5 0 1 0 0 5h4a4.5 4.5 0 1 1 0 9H11a1 1 0 1 1 0-2h3.5a2.5 2.5 0 0 0 0-5h-4a4.5 4.5 0 1 1 0-9H15a1 1 0 1 1 0 2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M8 19a3 3 0 1 1-6 0 3 3 0 0 1 6 0" })
    ]
  }
), ca = o(a2), e2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5 5a4 4 0 1 0 0 8h14a4 4 0 0 0 0-8zM3 9a2 2 0 0 1 2-2h14a2 2 0 1 1 0 4H5a2 2 0 0 1-2-2M12 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6m-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
        clipRule: "evenodd"
      }
    )
  }
), wa = o(e2), o2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.5 6a2.5 2.5 0 1 0 0 5h3a4.5 4.5 0 1 1 0 9H11a1 1 0 1 1 0-2h2.5a2.5 2.5 0 0 0 0-5h-3a4.5 4.5 0 1 1 0-9H13a1 1 0 1 1 0 2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M19 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
        clipRule: "evenodd"
      }
    )
  }
), sa = o(o2), n2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M14 6a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5 22a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h11.172a3 3 0 0 1 2.12.879l2.83 2.828A3 3 0 0 1 22 7.828V19a3 3 0 0 1-3 3zM5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1v-4a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v4h1a1 1 0 0 0 1-1V7.828a1 1 0 0 0-.293-.707L17 4.414V8a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V4zm11 16v-4a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v4zM14 9a1 1 0 0 0 1-1V4H8v4a1 1 0 0 0 1 1z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ga = o(n2), i2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 2a1 1 0 0 1 1 1v1h5a1 1 0 0 1 .931.635l2.584 6.593c.35.896.863 2.398.082 3.72A4.22 4.22 0 0 1 18 17a4.2 4.2 0 0 1-3.591-2.06c-.77-1.32-.263-2.812.085-3.706L16.537 6H13v14h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V6H7.466l2.049 5.228c.35.896.864 2.398.082 3.72A4.22 4.22 0 0 1 6 17a4.2 4.2 0 0 1-3.591-2.06c-.77-1.32-.263-2.812.085-3.706l2.574-6.597A1 1 0 0 1 6 4h5V3a1 1 0 0 1 1-1M6.002 7.746l-1.644 4.215c-.375.96-.456 1.57-.223 1.97A2.2 2.2 0 0 0 6 15c.773 0 1.501-.436 1.875-1.07.235-.397.155-1.008-.222-1.973zm12 0 1.65 4.211c.378.964.458 1.576.223 1.974A2.22 2.22 0 0 1 18 15a2.2 2.2 0 0 1-1.864-1.07c-.234-.398-.153-1.009.222-1.969z",
        clipRule: "evenodd"
      }
    )
  }
), fa = o(i2), r2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9.5 3a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M1 9.5a8.5 8.5 0 1 1 15.176 5.262l5.531 5.53a1 1 0 0 1-1.414 1.415l-5.531-5.531A8.5 8.5 0 0 1 1 9.5",
        clipRule: "evenodd"
      }
    )
  }
), ua = o(r2), t2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M18.707 1.293a1 1 0 0 1 0 1.414L14.414 7 17 9.586l4.293-4.293a1 1 0 1 1 1.414 1.414L19.914 9.5l.438.437a2.21 2.21 0 0 1 0 3.126l-1.29 1.29a2.2 2.2 0 0 1-1.563.647H15.5a.2.2 0 0 0-.148.062l-.439.438q-.052.052-.106.1a2.21 2.21 0 0 1-.457 2.463l-2.288 2.289A2.21 2.21 0 0 1 9 20.413l-2.294 2.294a1 1 0 0 1-1.414-1.414L7.586 19 5 16.414l-2.293 2.293a1 1 0 0 1-1.414-1.414l2.294-2.294a2.21 2.21 0 0 1 .061-3.062l2.29-2.289A2.21 2.21 0 0 1 8.4 9.192q.046-.054.099-.106l.438-.439A.2.2 0 0 0 9 8.5V6.5c0-.586.233-1.148.647-1.563l1.29-1.29a2.21 2.21 0 0 1 3.126 0l.437.438 2.793-2.793a1 1 0 0 1 1.414 0M13.086 5.5l-.437-.437a.21.21 0 0 0-.297 0l-1.29 1.29A.2.2 0 0 0 11 6.5V8.5a2.2 2.2 0 0 1-.647 1.563l-.439.438 3.586 3.586.438-.439A2.2 2.2 0 0 1 15.502 13H17.5a.2.2 0 0 0 .148-.062l1.29-1.29a.21.21 0 0 0 0-.296l-.437-.438-.086.086a2 2 0 0 1-2.828 0L13 8.414a2 2 0 0 1 0-2.828zM8.5 11.914l-.852-.851a.21.21 0 0 0-.296 0l-2.29 2.288a.21.21 0 0 0 0 .297l5.29 5.29a.21.21 0 0 0 .297 0l2.288-2.29a.21.21 0 0 0 0-.296z",
        clipRule: "evenodd"
      }
    )
  }
), pa = o(t2), h2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14.707 7.793a1 1 0 1 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.414-1.414z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m22.352 7.937-.438-.437.793-.793a1 1 0 0 0-1.414-1.414L19 7.586 16.414 5l2.293-2.293a1 1 0 0 0-1.414-1.414l-.793.793-.437-.438a2.21 2.21 0 0 0-3.126 0l-1.29 1.29A2.2 2.2 0 0 0 11 4.501V6a.2.2 0 0 1-.062.148l-1.29 1.29a2.21 2.21 0 0 0 0 3.126l3.79 3.788a2.21 2.21 0 0 0 3.125 0l1.29-1.29A.2.2 0 0 1 18 13H19.5a2.2 2.2 0 0 0 1.563-.647l1.29-1.29a2.21 2.21 0 0 0 0-3.126M15 3.586a2 2 0 0 0 0 2.828L17.586 9a2 2 0 0 0 2.828 0l.086-.086.437.438a.21.21 0 0 1 0 .296l-1.29 1.29A.2.2 0 0 1 19.5 11H18a2.2 2.2 0 0 0-1.562.647l-1.29 1.29a.21.21 0 0 1-.297 0l-3.79-3.788a.21.21 0 0 1 0-.297l1.29-1.29A2.2 2.2 0 0 0 13 5.999V4.5a.2.2 0 0 1 .062-.148l1.29-1.29a.21.21 0 0 1 .297 0l.437.437zM4 17.414l-1.293 1.293a1 1 0 0 1-1.414-1.414l1.294-1.294a2.21 2.21 0 0 1 .061-3.062l2.29-2.288a2.21 2.21 0 0 1 3.125 0l5.288 5.288a2.21 2.21 0 0 1 0 3.126l-2.288 2.289A2.21 2.21 0 0 1 8 21.413l-1.294 1.294a1 1 0 0 1-1.414-1.414L6.586 20zm5.352 2.523-.645-.644-4.644-4.644a.21.21 0 0 1 0-.297l2.289-2.29a.21.21 0 0 1 .296 0l5.29 5.29a.21.21 0 0 1 0 .296l-2.29 2.29a.21.21 0 0 1-.296 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ra = o(h2), d2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10.75 16.996a1.25 1.25 0 1 0 2.5.007 1.25 1.25 0 0 0-2.5-.007",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1c0 1.55-.881 2.894-2.17 3.558a9 9 0 1 1-15.658 0A4 4 0 0 1 1.999 5zm4.255 5A6.96 6.96 0 0 0 5 13c0 1.958.804 3.728 2.1 4.999a5 5 0 1 1 9.8 0A6.98 6.98 0 0 0 19 13a6.96 6.96 0 0 0-1.255-4zM12 20a3 3 0 1 0 0-6 3 3 0 0 0 0 6m8-16H4v1a2 2 0 0 0 2 2h12q.08 0 .16-.006A2 2 0 0 0 20 5z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ma = o(d2), v2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 2a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M9.401 2.504c1.155-2.002 4.043-2.002 5.198 0l.393.681a1 1 0 0 0 1.125.467l.76-.204c2.232-.6 4.274 1.443 3.675 3.675l-.204.76a1 1 0 0 0 .467 1.125l.681.393c2.002 1.155 2.002 4.043 0 5.198l-.681.393a1 1 0 0 0-.467 1.125l.204.76c.6 2.232-1.443 4.274-3.675 3.675l-.76-.204a1 1 0 0 0-1.125.467l-.393.681c-1.155 2.002-4.043 2.002-5.198 0l-.393-.681a1 1 0 0 0-1.125-.467l-.76.204c-2.232.6-4.274-1.443-3.675-3.675l.204-.76a1 1 0 0 0-.467-1.125l-.681-.393c-2.002-1.155-2.002-4.043 0-5.198l.681-.393a1 1 0 0 0 .467-1.125l-.204-.76c-.6-2.232 1.443-4.274 3.675-3.675l.76.204a1 1 0 0 0 1.125-.467zm3.465.999a1 1 0 0 0-1.732 0l-.393.682a3 3 0 0 1-3.377 1.398l-.76-.204A1 1 0 0 0 5.38 6.604l.204.76a3 3 0 0 1-1.398 3.377l-.682.393a1 1 0 0 0 0 1.732l.682.393a3 3 0 0 1 1.398 3.377l-.204.76a1 1 0 0 0 1.225 1.225l.76-.204a3 3 0 0 1 3.377 1.398l.393.682a1 1 0 0 0 1.732 0l.393-.682a3 3 0 0 1 3.377-1.398l.76.204a1 1 0 0 0 1.225-1.225l-.204-.76a3 3 0 0 1 1.398-3.377l.682-.393a1 1 0 0 0 0-1.732l-.682-.393a3 3 0 0 1-1.398-3.377l.204-.76a1 1 0 0 0-1.225-1.225l-.76.204a3 3 0 0 1-3.377-1.398z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ma = o(v2), c2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 1.4 3.04l-3.653 2.558a3.992 3.992 0 0 1 0 2.805l3.654 2.557a4 4 0 1 1-1.148 1.638L8.599 15.04a4 4 0 1 1 0-6.08l3.654-2.558A4 4 0 0 1 12 5m-6 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m10 7a1.997 1.997 0 0 0-2 2 2 2 0 1 0 2-2",
        clipRule: "evenodd"
      }
    )
  }
), Ca = o(c2), w2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.293 1.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 4.414V14a1 1 0 1 1-2 0V4.414L8.707 6.707a1 1 0 0 1-1.414-1.414zM7 11c-.548 0-1 .452-1 1v8c0 .548.452 1 1 1h10c.548 0 1-.452 1-1v-8c0-.548-.452-1-1-1h-1a1 1 0 1 1 0-2h1c1.652 0 3 1.348 3 3v8c0 1.652-1.348 3-3 3H7c-1.652 0-3-1.348-3-3v-8c0-1.652 1.348-3 3-3h1a1 1 0 0 1 0 2z",
        clipRule: "evenodd"
      }
    )
  }
), xa = o(w2), s2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.633 3.265a2 2 0 0 0-1.265 0l-6 2A2 2 0 0 0 4 7.162v4.773c.326 2.425 2.382 7.5 8 9.032 5.618-1.531 7.674-6.606 8-9.031V7.161a2 2 0 0 0-1.367-1.897zm-1.898-1.897a4 4 0 0 1 2.53 0l6 2A4 4 0 0 1 22 7.162V12q0 .062-.008.124c-.358 2.862-2.736 8.95-9.487 10.778-.33.089-.68.089-1.01 0-6.75-1.829-9.13-7.916-9.487-10.778A1 1 0 0 1 2 12V7.162a4 4 0 0 1 2.735-3.794z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17.226 8.294a1 1 0 0 1-.002 1.414l-6.018 6a1 1 0 0 1-1.538-.153l-2-3a1 1 0 1 1 1.664-1.11l1.324 1.987 5.156-5.14a1 1 0 0 1 1.414.002",
          clipRule: "evenodd"
        }
      )
    ]
  }
), za = o(s2), g2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.464 7.05a1 1 0 0 1 0 1.414 5 5 0 0 0 0 7.072A1 1 0 1 1 7.05 16.95a7 7 0 0 1 0-9.9 1 1 0 0 1 1.414 0M15.536 16.95a1 1 0 0 1 0-1.414 5 5 0 0 0 0-7.072A1 1 0 0 1 16.95 7.05a7 7 0 0 1 0 9.9 1 1 0 0 1-1.414 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M5.636 4.222a1 1 0 0 1 0 1.414 9 9 0 0 0 0 12.728 1 1 0 1 1-1.414 1.414c-4.296-4.296-4.296-11.26 0-15.556a1 1 0 0 1 1.414 0M18.364 19.778a1 1 0 0 1 0-1.414 9 9 0 0 0 0-12.728 1 1 0 1 1 1.414-1.414c4.296 4.296 4.296 11.26 0 15.556a1 1 0 0 1-1.414 0M13 14.83a3.001 3.001 0 1 0-2 0V21a1 1 0 1 0 2 0zM11 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Sa = o(g2), f2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m19.235 5.32-.027-.027A1 1 0 0 0 18.501 5a1 1 0 0 0-.735.32l-2.473 2.474a1 1 0 0 0 1.414 1.414l.794-.794V17a1 1 0 0 0 2 0V8.415l.793.793a1 1 0 1 0 1.414-1.414zM2 7a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 17a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), Ha = o(f2), u2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m19.235 18.683-.027.027a1 1 0 0 1-.707.293 1 1 0 0 1-.735-.32l-2.473-2.474a1 1 0 0 1 1.414-1.414l.794.794V7a1 1 0 0 1 2 0v8.588l.793-.793a1 1 0 1 1 1.414 1.414zM2 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1M2 17a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), Aa = o(u2), p2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 5a9 9 0 0 0-9 9c0 1.706.474 3.298 1.296 4.656.117.192.366.345.703.345h14.003c.336-.001.586-.154.703-.346A8.95 8.95 0 0 0 21 14a9 9 0 0 0-9-9M1 14C1 7.925 5.925 3 12 3s11 4.925 11 11c0 2.08-.579 4.03-1.585 5.69-.534.884-1.492 1.31-2.413 1.31H4.999c-.921.001-1.879-.425-2.414-1.308A10.95 10.95 0 0 1 1 14m11-5a5 5 0 0 0-4.714 6.667 1 1 0 1 1-1.886.666A7 7 0 0 1 12 7a1 1 0 1 1 0 2m5.207-.207a1 1 0 0 1 0 1.414l-3.275 3.275Q14 13.73 14 14a2 2 0 1 1-1.482-1.932l3.275-3.275a1 1 0 0 1 1.414 0",
        clipRule: "evenodd"
      }
    )
  }
), Va = o(p2), R2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0H4v5h5zM13 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm7 0h-5v5h5zM2 15a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0H4v5h5zM13 15a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2zm7 0h-5v5h5z",
        clipRule: "evenodd"
      }
    )
  }
), Ba = o(R2), M2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M19.553 15.106a1 1 0 0 1 .894 1.789l-8 4a1 1 0 0 1-.894 0l-8-4-.09-.051a1 1 0 0 1 .89-1.78l.094.041L12 18.883zm0-4a1 1 0 0 1 .894 1.789l-8 4a1 1 0 0 1-.894 0l-8-4-.09-.051a1 1 0 0 1 .89-1.78l.094.041L12 14.883zM11.66 3.06a1 1 0 0 1 .787.045l8 4 .121.072a1 1 0 0 1-.12 1.718l-8 4a1 1 0 0 1-.895 0l-8-4a1 1 0 0 1 0-1.79l8-4zM6.236 8 12 10.882 17.764 8 12 5.118z"
      }
    )
  }
), Fa = o(M2), m2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M12.905 1.574a1 1 0 0 0-1.81.002L8.24 7.672l-6.39.976a1 1 0 0 0-.565 1.687L5.94 15.1l-1.105 6.74a1 1 0 0 0 1.47 1.036l5.696-3.144 5.711 3.145a1 1 0 0 0 1.47-1.038l-1.105-6.74 4.64-4.764a1 1 0 0 0-.566-1.686l-6.376-.976z"
      }
    )
  }
), Ia = o(m2), C2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.999 1a1 1 0 0 1 .906.574l2.87 6.098 6.376.976a1 1 0 0 1 .565 1.686l-4.64 4.764 1.105 6.74a1 1 0 0 1-1.469 1.038l-5.711-3.145-5.696 3.144a1 1 0 0 1-1.47-1.037L5.94 15.1l-4.655-4.764a1 1 0 0 1 .564-1.687l6.391-.976 2.854-6.096A1 1 0 0 1 12 1m.003 3.353L9.825 9.004a1 1 0 0 1-.755.565l-4.993.762 3.646 3.732a1 1 0 0 1 .272.86l-.853 5.206 4.375-2.416a1 1 0 0 1 .965 0l4.393 2.419-.854-5.208a1 1 0 0 1 .27-.86l3.637-3.733-4.982-.762a1 1 0 0 1-.754-.563z",
        clipRule: "evenodd"
      }
    )
  }
), La = o(C2), x2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12m2.055-1A9 9 0 0 1 12 3a9 9 0 0 1 8.945 8h-3.418a3 3 0 0 0-3.001-3H9.474a3 3 0 0 0-3.001 3zM11 20.945A9 9 0 0 1 3.055 13h3.78l.348 1.629A3 3 0 0 0 10.117 17H11zm2 0A9 9 0 0 0 20.945 13h-3.78l-.348 1.629A3 3 0 0 1 13.883 17H13zM13.883 15h-3.766a1 1 0 0 1-.978-.79l-.643-3A1 1 0 0 1 9.474 10h5.052a1 1 0 0 1 .978 1.21l-.643 3a1 1 0 0 1-.978.79",
        clipRule: "evenodd"
      }
    )
  }
), $a = o(x2), z2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zM13 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0zM18 11a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M10 2a3 3 0 0 0-3 3v1H5a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-6a4 4 0 0 0-4-4h-2V5a3 3 0 0 0-3-3zm5 4V5a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1zM5 8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.75 22.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M15.75 22.004a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
), Pa = o(z2), S2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 1a1 1 0 0 1 1 1v1.5a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1m7.778 3.222a1 1 0 0 1 0 1.414l-1.06 1.06a1 1 0 1 1-1.415-1.414l1.061-1.06a1 1 0 0 1 1.414 0m-15.556 0a1 1 0 0 1 1.414 0l1.06 1.06a1 1 0 0 1-1.414 1.415l-1.06-1.061a1 1 0 0 1 0-1.414M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0m16 1h-1.5a1 1 0 1 1 0-2H22a1 1 0 1 1 0 2M1 12a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1m5.697 5.303a1 1 0 0 1 0 1.414l-1.06 1.061a1 1 0 0 1-1.415-1.414l1.06-1.06a1 1 0 0 1 1.415 0m10.606 0a1 1 0 0 1 1.414 0l1.061 1.06a1 1 0 0 1-1.414 1.415l-1.06-1.06a1 1 0 0 1 0-1.415M12 19.5a1 1 0 0 1 1 1V22a1 1 0 1 1-2 0v-1.5a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), ka = o(S2), H2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm2 10v2a1 1 0 0 0 1 1h3v-3zm4-2H3v-3h4zm2 2v3h11a1 1 0 0 0 1-1v-2zm12-2H9v-3h12zm0-5V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v3z",
        clipRule: "evenodd"
      }
    )
  }
), ya = o(H2), A2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M11.727 2.836A3 3 0 0 1 13.805 2H19a3 3 0 0 1 3 3v5.172a3 3 0 0 1-.879 2.12l-9.956 9.957a3 3 0 0 1-4.306-.065l-5.226-5.553a3 3 0 0 1 .113-4.226l2.228-2.126.002-.002zM4.65 12.398l-1.523 1.454a1 1 0 0 0-.038 1.409l5.226 5.552a1 1 0 0 0 1.436.022l1.668-1.668zm8.183 5.355 6.874-6.874a1 1 0 0 0 .293-.707V5a1 1 0 0 0-1-1h-5.195a1 1 0 0 0-.693.279l-7.017 6.736z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M15.25 7.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Da = o(A2), V2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3a2 2 0 0 0-2 2v8.5l-.4.3a4 4 0 1 0 4.799 0L14 13.5V5a2 2 0 0 0-2-2M8 5a4 4 0 1 1 8 0v7.528a6 6 0 1 1-8 0zm4 3a1 1 0 0 1 1 1v5.17a3.001 3.001 0 1 1-2 0V9a1 1 0 0 1 1-1m0 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
        clipRule: "evenodd"
      }
    )
  }
), Ea = o(V2), B2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.604 21.805A3.01 3.01 0 0 0 15 23h.12c2.087 0 3.542-2.086 2.807-4.05l-1.484-3.953 3.862-.007.063-.008A3.01 3.01 0 0 0 23 12V5a2.99 2.99 0 0 0-2.774-2.987l-.038-.003L8.001 2C6.349 2 5 3.348 5 5v8c0 1.102.898 2 2 2 .31 0 .607.147.802.403zm1.594-1.208-4.802-6.402A3.01 3.01 0 0 0 7 13V5c0-.548.452-1 1-1l12.105.01A.99.99 0 0 1 21 5v7c0 .486-.347.902-.835.99l-6.608.013 2.496 6.647A1 1 0 0 1 15.12 21H15c-.31 0-.607-.147-.802-.403M2 3a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), ba = o(B2), F2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.604 2.195A3.01 3.01 0 0 1 15 1h.12c2.087 0 3.542 2.086 2.807 4.05l-1.484 3.953 3.862.007.063.008A3.01 3.01 0 0 1 23 12v7a2.99 2.99 0 0 1-2.774 2.987l-.038.003L8.001 22C6.349 22 5 20.652 5 19v-8c0-1.102.898-2 2-2 .31 0 .607-.147.802-.403zm1.594 1.208L9.396 9.805A3.01 3.01 0 0 1 7 11v8c0 .547.452 1 1 1l12.105-.01A.99.99 0 0 0 21 19v-7c0-.486-.347-.902-.835-.99l-6.608-.013 2.496-6.647A1 1 0 0 0 15.12 3H15c-.31 0-.607.147-.802.403M2 10a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), Wa = o(F2), I2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M18.293 2.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414l-.29-.29-.723.727A9.97 9.97 0 0 1 22 13c0 5.523-4.477 10-10 10S2 18.523 2 13 6.477 3 12 3c2.148 0 4.137.677 5.767 1.83l.821-.828-.295-.295a1 1 0 0 1 0-1.414m-1.096 4.625A8 8 0 1 0 6.803 19.082 8 8 0 0 0 17.197 6.918",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 7a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M14 1a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1",
          clipRule: "evenodd"
        }
      )
    ]
  }
), qa = o(I2), L2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l("path", { fill: "currentColor", d: "M13 2a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0z" }),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.5 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M15.5 7.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M19 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M17 16c0-.548.452-1 1-1h2c.548 0 1 .452 1 1v3a1 1 0 1 0 2 0v-3c0-1.652-1.348-3-3-3h-2c-1.652 0-3 1.348-3 3v3a1 1 0 1 0 2 0zM4.037 15.704l-1.08 3.584a1 1 0 1 1-1.914-.576l1.08-3.585c.856-2.835 4.887-2.836 5.744-.002l1.09 3.584a1 1 0 0 1-1.914.582l-1.09-3.587c-.284-.939-1.632-.939-1.916 0"
        }
      )
    ]
  }
), Ta = o(L2), $2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 2a1 1 0 0 0-2 0v9a2 2 0 0 0-2 2v7a3 3 0 1 0 6 0v-7a2 2 0 0 0-2-2zM5 13h2v7a1 1 0 1 1-2 0zm9-10.584a1 1 0 0 0-1.4-.916 6.001 6.001 0 0 0-.6 10.697V20a3 3 0 1 0 6 0v-7.803A6.001 6.001 0 0 0 17.4 1.5a1 1 0 0 0-1.4.916V6.5l-1 .75-1-.75zM11 7c0-1.014.377-1.94 1-2.646V6.5a2 2 0 0 0 .8 1.6l1 .75a2 2 0 0 0 2.4 0l1-.75a2 2 0 0 0 .8-1.6V4.354a4.001 4.001 0 0 1-1.4 6.314 1 1 0 0 0-.6.916V20a1 1 0 1 1-2 0v-8.416a1 1 0 0 0-.6-.916A4 4 0 0 1 11 7",
        clipRule: "evenodd"
      }
    )
  }
), Ua = o($2), P2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3 4a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a4 4 0 0 1-3.064 3.89l.93 1.61a1 1 0 1 1-1.732 1L15.691 20H8.309l-1.443 2.5a1 1 0 1 1-1.732-1l.93-1.61A4 4 0 0 1 3 16zm4.751 14H7a2 2 0 0 1-2-2v-2h14v2a2 2 0 0 1-2 2H7.751M19 12V9H5v3zM5 7h14V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1zm3-2a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1M7 16a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m7 0a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), ja = o(P2), k2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M12 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1M16 9a1 1 0 0 1 1 1v8a1 1 0 1 1-2 0v-8a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7 5V4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h5a1 1 0 1 1 0 2h-1v12a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7H2a1 1 0 1 1 0-2zm2 0h6V4a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1zM5 7v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Na = o(k2), y2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m18.707 9.707-6 6a1 1 0 0 1-1.414 0l-6-6A1 1 0 0 1 6 8h12a1 1 0 0 1 .707 1.707"
      }
    )
  }
), Oa = o(y2), D2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M12.768 2.36a1 1 0 0 0-1.536 0l-5 6A1 1 0 0 0 7 10h10a1 1 0 0 0 .768-1.64zM12.768 21.64a1 1 0 0 1-1.536 0l-5-6A1 1 0 0 1 7 14h10a1 1 0 0 1 .768 1.64z"
      }
    )
  }
), Xa = o(D2), E2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12.707 6.793a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414L11 9.914V16.5a1 1 0 1 0 2 0V9.914l1.293 1.293a1 1 0 0 0 1.414-1.414z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 1c6.076 0 11 4.924 11 11s-4.924 11-11 11q-1.1-.002-2.146-.21a1 1 0 1 1 .388-1.961A9 9 0 0 0 21 12a9 9 0 0 0-10.758-8.829 1 1 0 0 1-.388-1.962A11 11 0 0 1 12 1M5.887 2.853A1 1 0 1 1 7 4.515 9.1 9.1 0 0 0 4.515 7a1 1 0 0 1-1.662-1.113 11.1 11.1 0 0 1 3.034-3.034M1.21 9.854a1 1 0 1 1 1.961.388 9 9 0 0 0 0 3.516 1 1 0 1 1-1.962.388 11 11 0 0 1 0-4.292M2.853 18.113A1 1 0 0 1 4.515 17 9.1 9.1 0 0 0 7 19.485a1 1 0 0 1-1.113 1.662 11.1 11.1 0 0 1-3.034-3.034"
        }
      )
    ]
  }
), Ga = o(E2), b2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 14a1 1 0 0 1 1 1v3.92A3.08 3.08 0 0 1 17.92 22H6a3 3 0 0 1-3-3v-4a1 1 0 1 1 2 0v4a1 1 0 0 0 1 1h11.92A1.08 1.08 0 0 0 19 18.92V15a1 1 0 0 1 1-1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M7.293 7.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1-1.414 1.414L13 5.414V13a1 1 0 1 1-2 0V5.414L8.707 7.707a1 1 0 0 1-1.414 0",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Qa = o(b2), W2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.035 1.584a1.99 1.99 0 0 1 2.817 0l5.564 5.564c.779.778.779 2.039 0 2.817l-4.567 4.568.613.614a1.245 1.245 0 0 1 0 1.76l-4.683 4.684a3.985 3.985 0 0 1-5.635 0l-.67-.669-1.785 1.786A.996.996 0 1 1 4.28 21.3l1.786-1.786-1.58-1.58L2.7 19.72a.996.996 0 0 1-1.408-1.409l1.786-1.786-.67-.669a3.984 3.984 0 0 1 0-5.635l4.684-4.683a1.245 1.245 0 0 1 1.761 0l.614.613zm-3.16 5.976 5.565 5.564 4.568-4.568-5.564-5.564zm-2.902-.085L3.817 11.63a1.99 1.99 0 0 0 0 2.818l5.735 5.735c.778.778 2.04.778 2.818 0l4.155-4.156zm8.175-2.113a.996.996 0 0 1 0 1.408l-.996.997a.996.996 0 1 1-1.409-1.41l.996-.995a.996.996 0 0 1 1.409 0m2.49 2.49a.996.996 0 0 1 0 1.409l-.996.996a.996.996 0 1 1-1.408-1.409l.996-.996a.996.996 0 0 1 1.408 0",
        clipRule: "evenodd"
      }
    )
  }
), Ka = o(W2), q2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11 4a1 1 0 0 1 1-1h6a3 3 0 0 1 3 3v4a1 1 0 1 1-2 0V6a1 1 0 0 0-1-1h-6a1 1 0 0 1-1-1M4 15a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h5.111a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3v-2a1 1 0 0 1 1-1M5.736 10a1 1 0 0 0-.894.553l-.948 1.894a1 1 0 1 1-1.788-.894l.947-1.895A3 3 0 0 1 5.736 8h1.528a3 3 0 0 1 2.683 1.658l.947 1.895a1 1 0 1 1-1.788.894l-.948-1.894A1 1 0 0 0 7.264 10zM6.5 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M16.5 11a4.5 4.5 0 1 0 2.396 8.31l2.397 2.397a1 1 0 0 0 1.414-1.414l-2.397-2.397A4.5 4.5 0 0 0 16.5 11M14 15.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0",
        clipRule: "evenodd"
      }
    )
  }
), Ja = o(q2), T2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M9 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 6.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m10-3a1 1 0 0 1 1-1 4 4 0 0 1 0 8 1 1 0 1 1 0-2 2 2 0 1 0 0-4 1 1 0 0 1-1-1M7.16 14a1 1 0 0 0-.868.504l-3.424 5.992a1 1 0 1 1-1.736-.992l3.424-5.992A3 3 0 0 1 7.16 12h3.678a3 3 0 0 1 2.605 1.512l3.424 5.992a1 1 0 1 1-1.736.992l-3.424-5.992a1 1 0 0 0-.869-.504zM15 13a1 1 0 0 1 1-1h.84a3 3 0 0 1 2.604 1.512l3.424 5.992a1 1 0 1 1-1.736.992l-3.424-5.992a1 1 0 0 0-.869-.504H16a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), Ya = o(T2), U2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M17 1c-1.652 0-3 1.348-3 3v7c0 1.652 1.348 3 3 3h.17a3.001 3.001 0 1 0 0-2H17c-.548 0-1-.452-1-1V4c0-.548.452-1 1-1h5a1 1 0 1 0 0-2zm2 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0M1 9a1 1 0 0 1 1-1h5.87c1.053 0 2.028.556 2.568 1.456l2.19 3.64c.071.119.177.233.311.325l1.732 1.155.002.001a3 3 0 0 1 1.337 2.493V20a1 1 0 0 1-1 1h-2.18a3.001 3.001 0 0 1-5.66 0H2a1 1 0 1 1 0-2h5.17a3.001 3.001 0 0 1 5.66 0h1.18v-1.93a1 1 0 0 0-.441-.826l-.004-.002-1.747-1.165a3.1 3.1 0 0 1-.905-.952l-2.19-3.64A1 1 0 0 0 7.87 10H2a1 1 0 0 1-1-1m9 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 12a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-.707-.293L3.586 16H2a1 1 0 1 1 0-2h2a1 1 0 0 1 .707.293l.707.707H6v-2H2a1 1 0 0 1-1-1M18 4a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z"
        }
      )
    ]
  }
), Za = o(U2), j2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20.815 2.38a1 1 0 1 0-1.85-.76l-1.64 4q-.016.04-.028.077a3 3 0 1 0 2.852-1.694zM19 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M14 1a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0V5h-1a1 1 0 1 1 0-2h1V2a1 1 0 0 1 1-1"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a1 1 0 1 0 0 2h8.87c.347 0 .672.184.853.485l2.19 3.64c.228.38.54.704.905.952l1.747 1.165.004.002a1 1 0 0 1 .441.826V19h-1.18a3.001 3.001 0 0 0-5.66 0H2a1 1 0 1 0 0 2h8.17a3.001 3.001 0 0 0 5.66 0h2.18a1 1 0 0 0 1-1v-2.93c0-.989-.493-1.934-1.337-2.493l-.002-.001-1.732-1.155a1.1 1.1 0 0 1-.312-.325l-2.19-3.64A3 3 0 0 0 10.87 8zm11 13a1 1 0 1 1 0-2 1 1 0 0 1 0 2",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M2 11a1 1 0 1 0 0 2h7v2h-.586l-.707-.707A1 1 0 0 0 7 14H2a1 1 0 1 0 0 2h4.586l.707.707A1 1 0 0 0 8 17h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
        }
      )
    ]
  }
), _a = o(j2), N2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.93 1.443a1 1 0 0 1 1.387-.274c.865.58 1.708 1.252 2.482 2.036a16.5 16.5 0 0 1 2.031 2.478 1 1 0 0 1-1.66 1.114 14.5 14.5 0 0 0-1.787-2.18l-.005-.005a14 14 0 0 0-2.175-1.782 1 1 0 0 1-.274-1.387M12.622 4.154a1 1 0 0 1 1.393-.242c.595.418 1.148.897 1.662 1.41.52.52.984 1.072 1.404 1.652a1 1 0 1 1-1.622 1.171q-.538-.748-1.196-1.408a10.7 10.7 0 0 0-1.399-1.19 1 1 0 0 1-.242-1.393M11.763 7.063a1 1 0 0 1 1.414 0l.71.71a1 1 0 1 1-1.414 1.414l-.71-.71a1 1 0 0 1 0-1.414"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 8a1 1 0 0 0 0 2h6.87c.347 0 .672.184.853.485l2.19 3.64c.228.38.54.704.905.952l1.747 1.165.004.002a1 1 0 0 1 .441.826V19h-1.18a3.001 3.001 0 0 0-5.66 0H2a1 1 0 1 0 0 2h6.17a3.001 3.001 0 0 0 5.66 0h2.18a1 1 0 0 0 1-1v-2.93c0-.989-.493-1.934-1.337-2.493l-.002-.001-1.732-1.155a1.1 1.1 0 0 1-.312-.325l-2.19-3.64A3 3 0 0 0 8.87 8zm8 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-.707-.293L4.586 16H2a1 1 0 1 1 0-2h3a1 1 0 0 1 .707.293l.707.707H7v-2H2a1 1 0 0 1-1-1M21 10a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1z"
        }
      )
    ]
  }
), le = o(N2), O2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2 3a1 1 0 0 0 0 2h11.13a.97.97 0 0 1 .836.46l3.187 5.072q.1.157.247.268l3.195 2.396.002.002c.256.195.403.493.403.802v4h-2.126a4.002 4.002 0 0 0-7.748 0H2a1 1 0 1 0 0 2h9.126a4.002 4.002 0 0 0 7.748 0H22a1 1 0 0 0 1-1v-5c0-.95-.452-1.832-1.195-2.396L18.748 9.31 15.67 4.413A2.97 2.97 0 0 0 13.13 3zm11 16a2 2 0 1 0 4 0 2 2 0 0 0-4 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M1 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v6.5a1 1 0 0 1-1 1H7.84a3 3 0 0 1-1.665-.508l-1.23-.82A1 1 0 0 0 4.39 13H2a1 1 0 1 1 0-2h2.39a3 3 0 0 1 1.665.508l1.23.82c.17.113.367.172.555.172H9V8H2a1 1 0 0 1-1-1"
        }
      )
    ]
  }
), ae = o(O2), X2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M2.293 2.293a1 1 0 0 1 1.414 0l18 18a1 1 0 0 1-1.414 1.414l-3.899-3.899A3 3 0 0 1 14 19H4a3 3 0 0 1-3-3V8a3 3 0 0 1 2.61-2.975L2.294 3.707a1 1 0 0 1 0-1.414M5.586 7l9.35 9.35A1 1 0 0 1 14 17H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9 6a1 1 0 0 1 1-1h4a3 3 0 0 1 3 3v.382l4.553-2.276A1 1 0 0 1 23 7v10a1 1 0 0 1-1.484.875l-2.25-1.246a1 1 0 1 1 .968-1.75l.766.424V8.618l-4 2V12a1 1 0 1 1-2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 1-1-1"
        }
      )
    ]
  }
), ee = o(X2), G2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-.626l4.516 2.5A1 1 0 0 0 23 17V7a1 1 0 0 0-1.447-.894L17 8.382V8a3 3 0 0 0-3-3zm13 5.618v2.47l4 2.215V8.618zM3 8a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z",
        clipRule: "evenodd"
      }
    )
  }
), oe = o(G2), Q2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 6a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm5.507 3.13a1 1 0 0 1 1.008.013l5 3a1 1 0 0 1 0 1.714l-5 3A1 1 0 0 1 9 15V9a1 1 0 0 1 .507-.87M11 10.766v2.468L13.056 12z",
        clipRule: "evenodd"
      }
    )
  }
), ne = o(Q2), K2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8 5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-6.894l-3.432 4.863A5 5 0 0 1 7.8 20.83l-4.558 1.14a1 1 0 1 1-.486-1.94l4.56-1.14a3 3 0 0 0 1.723-1.18l4.022-5.698a.894.894 0 0 0-1.403-1.104L9.55 13.317A2 2 0 0 1 8.046 14H6a1 1 0 1 1 0-2h2V8H7a3 3 0 0 0-2.4 1.2l-1.8 2.4a1 1 0 1 1-1.6-1.2L3 8a5 5 0 0 1 4-2h1zm2 4.767.154-.176A2.894 2.894 0 0 1 15.182 12H21V5H10z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M14 6.402a3 3 0 0 1 4.098 4.098 1 1 0 1 1-1.732-1A1 1 0 0 0 15 8.134a1 1 0 1 1-1-1.732",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ie = o(K2), J2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8.5 5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0m.867 7-.262 2.101a3 3 0 0 0 .535 2.116l4.546 6.364a1 1 0 1 0 1.628-1.162l-4.546-6.365a1 1 0 0 1-.179-.705L11.383 12H13a1 1 0 0 1 .8.4l.73.974a3 3 0 0 0 3.515.985l2.326-.93a1 1 0 0 0-.742-1.857l-2.327.93a1 1 0 0 1-1.172-.328l-.73-.974A3 3 0 0 0 13 10H8a3 3 0 0 0-2.4 1.2l-2.4 3.2a1 1 0 0 0 1.6 1.2l2.4-3.2A1 1 0 0 1 8 12zM8.6 17.2a1 1 0 0 1 .2 1.4l-3 4a1 1 0 1 1-1.6-1.2l3-4a1 1 0 0 1 1.4-.2",
        clipRule: "evenodd"
      }
    )
  }
), re = o(J2), Y2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521M13 13.5a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm-1 4.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
        clipRule: "evenodd"
      }
    )
  }
), te = o(Y2), Z2 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.044-6.186a1 1 0 0 0-1.414 1.414l1.793 1.793-1.793 1.793a1 1 0 1 0 1.414 1.414L12 15.914l1.793 1.793a1 1 0 0 0 1.414-1.414L13.414 14.5l1.793-1.793a1 1 0 0 0-1.414-1.414L12 13.086z",
        clipRule: "evenodd"
      }
    )
  }
), he = o(Z2), _2 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.975-13.014L2.886 18.493A1 1 0 0 0 3.748 20h16.504a1 1 0 0 0 .861-1.507L12.862 4.465a1 1 0 0 0-1.724 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.793 11.293a1 1 0 0 1 1.414 0L12 13.086l1.793-1.793a1 1 0 0 1 1.414 1.414L13.414 14.5l1.793 1.793a1 1 0 0 1-1.414 1.414L12 15.914l-1.793 1.793a1 1 0 0 1-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
), de = o(_2), l4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M1.163 17.479 9.414 3.45c1.16-1.972 4.012-1.972 5.172 0l8.251 14.028c1.177 2-.265 4.521-2.585 4.521H3.748c-2.32 0-3.762-2.521-2.585-4.521m9.975-13.014L2.886 18.493A1 1 0 0 0 3.748 20h16.504a1 1 0 0 0 .861-1.507L12.862 4.465a1 1 0 0 0-1.724 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 14.5a1 1 0 0 0 1-1v-4a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M13.25 17a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
        }
      )
    ]
  }
), ve = o(l4), a4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.5 2a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1M12 5a1 1 0 0 1 1 1v12a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1m9 1.5a1 1 0 0 1 1 1v9a1 1 0 1 1-2 0v-9a1 1 0 0 1 1-1M3 8a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m13.5 0a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
        clipRule: "evenodd"
      }
    )
  }
), ce = o(a4), e4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M8.83 3.256a1 1 0 0 0-.074 1.414c1.31 1.456 1.62 3.796.693 5.52l-.011.023c-.181.359-.434.722-.707 1.114-.533.767-1.142 1.644-1.438 2.808-.706 2.282-.086 4.776 1.457 6.527a1 1 0 1 0 1.5-1.324c-1.093-1.24-1.537-3.073-1.049-4.629l.01-.03.008-.03c.152-.618.545-1.206.995-1.878.327-.488.684-1.021.999-1.642 1.35-2.518.926-5.694-.969-7.799a1 1 0 0 0-1.414-.074M18.596 3.569a1 1 0 0 1 .957-.57 1 1 0 0 1 .691.331c1.895 2.105 2.32 5.281.969 7.799-.315.621-.672 1.154-.999 1.642-.45.672-.843 1.26-.995 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1 1 0 1 1-1.5 1.324c-1.543-1.75-2.163-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.525-.755.706-1.114l.012-.024c.927-1.723.617-4.063-.693-5.52a1 1 0 0 1-.16-1.1M14.166 3.057a1 1 0 0 1 1.078.273c1.895 2.105 2.32 5.282.969 7.799-.315.621-.672 1.154-.999 1.642-.45.672-.843 1.26-.995 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1 1 0 1 1-1.5 1.324c-1.543-1.75-2.164-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.525-.755.706-1.114l.012-.023c.927-1.723.617-4.064-.693-5.52a1 1 0 0 1 .074-1.414 1 1 0 0 1 .336-.199M4.166 3.057a1 1 0 0 1 1.078.273c1.895 2.105 2.32 5.282.969 7.799-.315.621-.672 1.154-1 1.642-.449.672-.842 1.26-.994 1.877l-.008.032-.01.029c-.488 1.556-.044 3.389 1.049 4.629a1.001 1.001 0 1 1-1.5 1.324c-1.543-1.75-2.163-4.245-1.457-6.527.296-1.164.905-2.04 1.438-2.808.273-.392.526-.755.707-1.114l.011-.023c.927-1.723.617-4.064-.693-5.52a1 1 0 0 1 .41-1.613"
      }
    )
  }
), we = o(e4), o4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M4 5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m12.735-2.68-.027-.027a.997.997 0 0 0-1.415 0l-.027.028-2.473 2.473a1 1 0 0 0 1.414 1.414l.794-.794V8a1 1 0 1 0 2 0V5.415l.793.793a1 1 0 0 0 1.414-1.414zM18.999 9a1 1 0 0 1 1 1v2.586l.794-.794a1 1 0 1 1 1.414 1.414l-2.473 2.473-.027.028a.997.997 0 0 1-1.415 0l-.027-.028-2.473-2.473a1 1 0 1 1 1.414-1.414l.793.793V10a1 1 0 0 1 1-1M8 11h2a1 1 0 1 0 0-2H7.25C6.56 9 6 9.56 6 10.25v3.5c0 .69.56 1.25 1.25 1.25h3.514a1 1 0 0 1 .894.553l.018.036 1.468 2.428a1 1 0 0 0 1.712-1.034l-1.429-2.364A3 3 0 0 0 10.764 13H8zm-3.121-.536a1 1 0 0 1 0 1.415A3 3 0 1 0 9.12 16.12a1 1 0 0 1 1.415 1.415 5 5 0 0 1-7.072-7.072 1 1 0 0 1 1.415 0M2 21a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1",
        clipRule: "evenodd"
      }
    )
  }
), se = o(o4), n4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0M5 8.01a1 1 0 0 1 1-1h4.34a2.995 2.995 0 0 1 2.88 3.827l-.267.928a6.5 6.5 0 0 1 1.53 2.19l3.31.025a3.02 3.02 0 0 1 2.649 1.657l.003.006 2.45 4.91a1 1 0 1 1-1.79.893l-2.447-4.904-.001-.002a1.02 1.02 0 0 0-.888-.56l-2.791-.02q.021.267.022.54a6.5 6.5 0 1 1-3.79-5.91l.09-.307a.995.995 0 0 0-.96-1.273H6a1 1 0 0 1-1-1M8.5 12a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9",
        clipRule: "evenodd"
      }
    )
  }
), ge = o(n4), i4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 6.252a12.74 12.74 0 0 0-8.945 3.667 1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M9.946 9.927a1 1 0 0 1-.622 1.27A8.3 8.3 0 0 0 6.23 13.1a1 1 0 0 1-1.397-1.431 10.3 10.3 0 0 1 3.843-2.365 1 1 0 0 1 1.27.623M14.054 9.927a1 1 0 0 1 1.27-.623 10.3 10.3 0 0 1 3.843 2.365A1 1 0 1 1 17.77 13.1a8.3 8.3 0 0 0-3.094-1.903 1 1 0 0 1-.622-1.27M14.224 14.684a1 1 0 0 1 1.407-.145q.182.149.352.311a1 1 0 1 1-1.385 1.444 4 4 0 0 0-.23-.203 1 1 0 0 1-.144-1.407M9.776 14.684a1 1 0 0 1-.145 1.407 4 4 0 0 0-.23.203 1 1 0 0 1-1.384-1.444q.17-.163.352-.31a1 1 0 0 1 1.407.144M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007M13 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
        }
      )
    ]
  }
), fe = o(i4), r4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 15.249c-.969 0-1.9.374-2.598 1.045a1 1 0 0 1-1.385-1.444 5.753 5.753 0 0 1 7.966 0 1 1 0 1 1-1.385 1.444A3.75 3.75 0 0 0 12 15.249",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 10.751a8.26 8.26 0 0 0-5.77 2.35 1 1 0 0 1-1.397-1.432 10.263 10.263 0 0 1 14.334 0A1 1 0 1 1 17.77 13.1 8.26 8.26 0 0 0 12 10.751",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 6.252c-3.348 0-6.56 1.317-8.945 3.667a1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007",
          clipRule: "evenodd"
        }
      )
    ]
  }
), ue = o(r4), t4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M5.707 4.293a1 1 0 0 0-1.414 1.414l.453.453A14.7 14.7 0 0 0 1.65 8.494a1 1 0 0 0 1.404 1.425 12.7 12.7 0 0 1 3.167-2.282l1.9 1.899a10.05 10.05 0 0 0-3.29 2.133A1 1 0 0 0 6.23 13.1a8.15 8.15 0 0 1 3.464-1.991l2.143 2.142a5.75 5.75 0 0 0-3.82 1.6 1 1 0 1 0 1.385 1.443A3.75 3.75 0 0 1 12 15.249c.766 0 1.667.23 2.235.593.287.184.496.319.634.452q.037.035.076.065l3.348 3.348a1 1 0 0 0 1.414-1.414L10.72 9.305l-.022-.022zM9.682 6.464A12.74 12.74 0 0 1 20.945 9.92a1 1 0 1 0 1.404-1.425 14.74 14.74 0 0 0-13.03-3.996 1 1 0 1 0 .363 1.966M13.024 9.754a1 1 0 0 1 1.192-.76c1.853.41 3.572 1.329 4.951 2.675A1 1 0 0 1 17.77 13.1a8.26 8.26 0 0 0-3.986-2.154 1 1 0 0 1-.76-1.192"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      )
    ]
  }
), pe = o(t4), h4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M12 6.252a12.74 12.74 0 0 0-8.945 3.667 1 1 0 0 1-1.404-1.425 14.744 14.744 0 0 1 20.698 0 1 1 0 1 1-1.404 1.425A12.74 12.74 0 0 0 12 6.252M7.305 10.967a1 1 0 0 1-.211 1.399 8 8 0 0 0-.864.734 1 1 0 0 1-1.397-1.431q.508-.495 1.073-.913a1 1 0 0 1 1.399.211M16.695 10.967a1 1 0 0 1 1.399-.21q.565.416 1.073.912A1 1 0 1 1 17.77 13.1a8 8 0 0 0-.864-.734 1 1 0 0 1-.21-1.399M9.464 14.86a1 1 0 0 1-.04 1.413l-.022.02a1 1 0 0 1-1.385-1.443l.033-.031a1 1 0 0 1 1.414.04M14.543 14.863a1 1 0 0 1 1.414-.038l.026.025a1 1 0 1 1-1.385 1.444l-.017-.017a1 1 0 0 1-.038-1.414M10.75 18.504a1.25 1.25 0 1 1 2.5-.007 1.25 1.25 0 0 1-2.5.007"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M8.6 11.4a3.4 3.4 0 0 1 6.8 0c0 1.486-.972 2.267-1.628 2.709-.275.185-.465.345-.59.513A.9.9 0 0 0 13 15.2v.3a1 1 0 1 1-2 0v-.3c0-1.506.984-2.298 1.654-2.75.268-.18.452-.334.572-.496a.87.87 0 0 0 .174-.554 1.4 1.4 0 0 0-2.8 0 1 1 0 1 1-2 0"
        }
      )
    ]
  }
), Re = o(h4), d4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M10.586 3.515a7 7 0 0 1 7.59-1.535c.865.352.998 1.431.404 2.026l-3.393 3.393.19 1.225 1.224.189 3.393-3.393c.595-.594 1.674-.461 2.026.404a7.002 7.002 0 0 1-8.836 9.235L7.05 21.193a3 3 0 0 1-4.243-4.243l6.134-6.134a7 7 0 0 1 1.645-7.301m5.657 0a5.002 5.002 0 0 0-5.282 6.972c.202.458.12 1.017-.259 1.397l-6.48 6.48a1 1 0 0 0 1.414 1.414l6.48-6.48c.38-.38.939-.462 1.397-.26a5.002 5.002 0 0 0 6.973-5.281l-2.47 2.47a2 2 0 0 1-1.72.563l-1.225-.19A2 2 0 0 1 13.4 8.93l-.19-1.226a2 2 0 0 1 .563-1.72z",
        clipRule: "evenodd"
      }
    )
  }
), Me = o(d4), v4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1 12c0 6.076 4.924 11 11 11s11-4.924 11-11S18.076 1 12 1 1 5.924 1 12m8.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586z",
        clipRule: "evenodd"
      }
    )
  }
), me = o(v4), c4 = (a, e) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9M1 12C1 5.924 5.924 1 12 1s11 4.924 11 11-4.924 11-11 11S1 18.076 1 12",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M8.293 8.293a1 1 0 0 1 1.414 0L12 10.586l2.293-2.293a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293a1 1 0 0 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 0 1 0-1.414",
          clipRule: "evenodd"
        }
      )
    ]
  }
), Ce = o(c4), w4 = (a, e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M5.293 5.293a1 1 0 0 1 1.414 0L12 10.586l5.293-5.293a1 1 0 1 1 1.414 1.414L13.414 12l5.293 5.293a1 1 0 0 1-1.414 1.414L12 13.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L10.586 12 5.293 6.707a1 1 0 0 1 0-1.414",
        clipRule: "evenodd"
      }
    )
  }
), xe = o(w4);
export {
  f4 as AccessibilityIcon,
  u4 as AchievementIcon,
  p4 as AdjustIcon,
  R4 as AdsHeartIcon,
  M4 as ArrowClockwiseIcon,
  m4 as ArrowCounterClockwiseIcon,
  C4 as ArrowDownIcon,
  x4 as ArrowLeftIcon,
  z4 as ArrowRightIcon,
  H4 as ArrowUpIcon,
  S4 as ArrowUpLeftIcon,
  A4 as ArrowsMaximizeIcon,
  V4 as ArrowsMinimizeIcon,
  B4 as BadgeIcon,
  F4 as BatteryChargingIcon,
  I4 as BatteryEmptyIcon,
  L4 as BatteryFullIcon,
  $4 as BatteryHealthIcon,
  P4 as BatteryLowIcon,
  k4 as BatteryMediumIcon,
  D4 as BellIcon,
  y4 as BellPlusIcon,
  E4 as BluetoothIcon,
  b4 as BoltIcon,
  W4 as BookOpenIcon,
  q4 as BusIcon,
  T4 as CalendarScheduleClockIcon,
  j4 as CalendarScheduleIcon,
  U4 as CalendarSchedulePlusIcon,
  O4 as CameraIcon,
  N4 as CameraPlusIcon,
  X4 as CarBatteryIcon,
  G4 as CarDoorIcon,
  Q4 as CarWindowIcon,
  K4 as ChargingStationIcon,
  Y4 as ChartBarIcon,
  J4 as ChartBarSquareIcon,
  _4 as CheckCircleIcon,
  Z4 as CheckCircleSolidIcon,
  a3 as CheckmarkIcon,
  l3 as CheckmarkSmallIcon,
  e3 as ChevronDownIcon,
  o3 as ChevronLeftIcon,
  n3 as ChevronRightIcon,
  i3 as ChevronUpIcon,
  r3 as ChildseatIcon,
  t3 as ClipboardChartIcon,
  h3 as ClipboardCheckIcon,
  d3 as ClipboardListIcon,
  v3 as ClockCounterIcon,
  c3 as ClockDashedIcon,
  w3 as ClockIcon,
  s3 as CoffeeIcon,
  g3 as CopyIcon,
  f3 as CounterIcon,
  u3 as CouponIcon,
  p3 as CurrencyCircleEuroIcon,
  R3 as DeviceDesktopIcon,
  M3 as DeviceMobileIcon,
  m3 as DoorOpenIcon,
  C3 as DownloadIcon,
  x3 as EmojiBadIcon,
  z3 as EmojiHappyIcon,
  S3 as EmojiOkayIcon,
  H3 as EmojiSadIcon,
  A3 as EmojiSmileIcon,
  B3 as ErrorCircleIcon,
  V3 as ErrorCircleSolidIcon,
  F3 as ErrorOctagonIcon,
  I3 as ExternalLinkIcon,
  L3 as EyeClosedIcon,
  P3 as EyeIcon,
  $3 as EyeSlashIcon,
  k3 as FileArchiveIcon,
  y3 as FileDraftIcon,
  E3 as FileIcon,
  D3 as FileTextIcon,
  b3 as FilesIcon,
  W3 as FilterIcon,
  q3 as FlagCheckedIcon,
  T3 as ForbiddenAltIcon,
  U3 as ForbiddenIcon,
  j3 as GiftIcon,
  N3 as GuideDogIcon,
  O3 as GuidepostIcon,
  X3 as HeadsetIcon,
  G3 as HomeEnterIcon,
  K3 as HomeIcon,
  Q3 as HomeSlashIcon,
  J3 as ImageIcon,
  Z3 as InfoIIcon,
  Y3 as InfoISolidIcon,
  _3 as InvoiceIcon,
  ll as KeyboardIcon,
  al as LightbulbIcon,
  el as LinkDiagonalIcon,
  ol as LinkHorizontalIcon,
  nl as ListIcon,
  rl as LockIcon,
  il as LockOpenIcon,
  tl as LogInIcon,
  hl as LogOutIcon,
  dl as MailCheckIcon,
  vl as MailIcon,
  cl as MapAdIcon,
  fl as MapIcon,
  gl as MapPinIcon,
  wl as MapPinPlusIcon,
  sl as MapPinRotateIcon,
  ul as MenuIcon,
  pl as MessageIcon,
  Ml as MicrophoneIcon,
  Rl as MicrophoneSlashIcon,
  Cl as MinusCircleIcon,
  ml as MinusCircleSolidIcon,
  xl as MinusIcon,
  zl as MoonIcon,
  Sl as MoreHorizontalIcon,
  Hl as MoreVerticalIcon,
  Al as NavigationArrowSolidIcon,
  Vl as NavigationCircleIcon,
  Bl as NavigationDirectionsIcon,
  Fl as NetworkIcon,
  Il as NoEmissionIcon,
  Ll as ParkingIcon,
  $l as PauseIcon,
  Pl as PaymentCardIcon,
  kl as PaymentCardsIcon,
  yl as PenIcon,
  Dl as PersonArrowIcon,
  Wl as PersonIcon,
  El as PersonPlusIcon,
  bl as PersonXIcon,
  ql as PhoneCallIcon,
  Tl as PhoneDownIcon,
  Ul as PhoneEmergencyIcon,
  jl as PhoneIcon,
  Ol as PinIcon,
  Nl as PinSolidIcon,
  Xl as PlayIcon,
  Ql as PlugIcon,
  Gl as PlugSlashIcon,
  Jl as PlusCircleIcon,
  Kl as PlusCircleSolidIcon,
  Yl as PlusIcon,
  Zl as PolygonSquareIcon,
  _l as PositionIcon,
  la as PowerIcon,
  aa as PriorityHighIcon,
  ea as PriorityHighestIcon,
  oa as PriorityLowIcon,
  na as PriorityLowestIcon,
  ia as PriorityNormalIcon,
  ra as QuestionCircleIcon,
  ta as ReloadIcon,
  ha as RoadIcon,
  da as RoadblockIcon,
  va as RouteEndIcon,
  sa as RouteIcon,
  ca as RouteStartIcon,
  wa as RouteStopIcon,
  ga as SaveIcon,
  fa as ScaleIcon,
  ua as SearchIcon,
  pa as SeatbeltClosedIcon,
  Ra as SeatbeltIcon,
  Ma as SecurityCameraIcon,
  ma as SettingsIcon,
  Ca as ShareAltIcon,
  xa as ShareIcon,
  za as ShieldCheckIcon,
  Sa as SignalMobileIcon,
  Ha as SortAscendingIcon,
  Aa as SortDescendingIcon,
  Va as SpeedometerIcon,
  Ba as SquaresIcon,
  Fa as StackIcon,
  La as StarIcon,
  Ia as StarSolidIcon,
  $a as SteeringWheelIcon,
  Pa as SuitcaseIcon,
  ka as SunIcon,
  ya as TableIcon,
  Da as TagIcon,
  Ea as ThermometerIcon,
  ba as ThumbDownIcon,
  Wa as ThumbUpIcon,
  qa as TimerIcon,
  Ta as ToiletIcon,
  Ua as ToolsIcon,
  ja as TrainIcon,
  Na as TrashIcon,
  Oa as TriangleDownIcon,
  Xa as TrianglesUpDownIcon,
  Ga as UploadCircleDashedIcon,
  Qa as UploadIcon,
  Ka as UsbPlugIcon,
  Ja as UserCheckIcon,
  Ya as UsersIcon,
  Za as VehicleFleetIcon,
  ae as VehicleIcon,
  _a as VehiclePlus6Icon,
  le as VehiclePlusAdIcon,
  oe as VideoCameraIcon,
  ee as VideoCameraSlashIcon,
  ne as VideoIcon,
  ie as VoucherIcon,
  re as WalkingPedestrianIcon,
  ve as WarningIcon,
  te as WarningSolidIcon,
  de as WarningXIcon,
  he as WarningXSolidIcon,
  ce as WaveformIcon,
  we as WavesVerticalIcon,
  ge as WheelchairIcon,
  se as WheelchairLiftIcon,
  fe as WifiErrorIcon,
  ue as WifiFullIcon,
  pe as WifiSlashIcon,
  Re as WifiUnknownIcon,
  Me as WrenchIcon,
  Ce as XCircleIcon,
  me as XCircleSolidIcon,
  xe as XIcon
};
